<template>
  <div id="oneclickReport" :class="{'sidebar-active': sidebarActive}">
    <!-- Loader -->
    <loader v-if="!isRender || loaderActive"></loader>

    <!-- 조건변경 영역 -->
    <div class="sidebar-wrap">
      <left-sidebar ref="leftSidebar"
                    v-if="isRender"
                    v-model="data"
                    :sidebarActive="sidebarActive"
                    @getAnalysisProfit="getAnalysisProfitInfo"
                    @getAnalysis="getAnalysisInfo"
                    @getProfit="getProfitInfo"
                    @getRecWeight="getRecWeight"
      >
      </left-sidebar>
      <div v-if="sidebarActive" class="sidebar-overlay hidden-lg" @click="sidebarActive = false"></div>
    </div>

    <!-- 사업성 검토 영역 -->
    <div class="preview-wrap">
      <div class="container preview-content">
        <div class="row">
          <!-- 지도정보 -->
          <section id="mapPreview">
            <daum-map v-if="requestState.map.state === 'success'"
                      ref="map"
                      :isOpen="true"
                      :mapData="data.oneclick_buji_result.map"
                      :setArea="true"
                      :setInfoWindow="true"
                      @open="openMap()">
            </daum-map>
            <div v-else-if="requestState.map.state === 'load'" class="data-loader">
              <bar-loader></bar-loader>
            </div>
            <div v-else class="data-text">{{ requestState.map.text }}</div>
          </section>
          <div :class="headerClass">
            <div class="title-box">
              <div class="sub-title margin-bottom-8">
                <span v-if="data.update_date" class="date-tag" style="margin-right: 8px;">저장 {{ data.update_date | nullCheck | formatDate }}</span>
                <span v-if="data.address" class="address-tag">{{ addressTag }}</span>
              </div>
              <div class="header-title">
                <div :class="['state-tag', stateTagClass]">{{ data.oneclick_grade }}</div>
                <!-- 프로젝트명 수정 영역 -->
                <div v-show="titleEdit" class="title-edit-box">
                  <input type="text"
                         maxlength="40"
                         class="hz-input-default hz-input-md project-title"
                         style="margin-left: 8px; width: calc(100% - 56px);"
                         v-model="data.project_name">
                  <button type="submit"
                          class="hz-btn-default hz-btn-md"
                          style="width: 40px; float: left; border-left: none; border-color: #ced4da; box-shadow: none;"
                          @click.prevent="titleEdit = false">완료</button>
                </div>
                <div v-show="!titleEdit" class="title-edit-box">
                  <p class="project-title" style="max-width: calc(100% - 48px); margin: 0 16px;">{{ data.project_name | nullCheck }}</p>
                  <i class="glyphicon glyphicon-pencil" @click="titleEdit = true"></i>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button v-if="isNewReport || hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg pull-right" style="width: 140px; margin-left: 8px;" @click.prevent="showSaveModal('save')">저장 후 미리보기</button>
              <button v-if="!isNewReport && !hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg pull-right" style="width: 140px; margin-left: 8px;" @click.prevent="openPreview">미리보기</button>
              <button v-if="hasAuthReport" type="button" class="hz-btn-default hz-btn-lg pull-right" style="margin-left: 8px;" @click.prevent="showSaveModal('copy')">다른이름으로 저장</button>
            </div>
          </div>
          <div :class="bodyClass">
            <!-- 토지정보 -->
            <section id="land">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4>부지정보</h4>
                    <button class="hz-btn-default hz-btn-xs" @click="updateLandInfo" title="부지정보 새로고침"><i class="glyphicon glyphicon-refresh"></i></button>
                    <button class="hz-btn-default hz-btn-xs" @click="showMenu('land')">부지평가</button>
                  </div>
                </div>
                <!-- 데이터 요청 성공 -->
                <div v-if="requestState.land.state === 'success'" class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th :rowspan="data.oneclick_buji_result['landInfo'].length + 2" class="title border-bottom-none">
                        토지<br>기본정보
                        <a href="javascript:void(0)" class="hz-btn-default hz-btn-xs" style="bottom: 48px;" @click="openSite('https://seereal.lh.or.kr/main.do')">자세히보기</a>
                        <a href="javascript:void(0)" class="hz-btn-default hz-btn-xs pull-right" @click="openSite('http://gis-heritage.go.kr/main.do')">문화재확인</a>
                      </th>
                      <th width="168px" class="bg-light-blue">지번(주소)</th>
                      <th width="100px">지목 <tooltip :title="tooltip.jimok.title" :html="tooltip.jimok.html" :size="'hz-lg-tooltip'"></tooltip></th>
                      <th width="120px">면적(평)</th>
                      <th width="150px">면적(㎡)</th>
                      <th>지역/지구/구역</th>
                    </tr>
                    <tr class="table-content" v-for="land in data.oneclick_buji_result['landInfo']">
                      <td class="bg-light-blue">{{ land['mnnmSlno'] | nullCheck }}</td>
                      <td>{{ land['lndcgrCodeNm'] | nullCheck }}</td>
                      <td>{{ land['lndpclArP'] | nullCheck | intcomma }}</td>
                      <td>{{ land['lndpclAr'] | nullCheck | intcomma }}</td>
                      <td>{{ land['landLaw']  | nullCheck }}</td>
                    </tr>
                    <tr class="table-content bg-dark-blue font-primary">
                      <td class="border-bottom-none font-weight-bold">합계</td>
                      <td class="border-bottom-none"></td>
                      <td class="border-bottom-none">{{ data.oneclick_buji_result.landInfoSum[0].sumLndpclArP | nullCheck | intcomma }}</td>
                      <td class="border-bottom-none">{{ data.oneclick_buji_result.landInfoSum[0].sumLndpclAr | nullCheck | intcomma }}</td>
                      <td class="border-bottom-none"></td>
                    </tr>
                  </table>
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th :rowspan="data.oneclick_buji_result['landInfo'].length + 2" class="title">
                        토지<br>추가정보
                      </th>
                      <th width="168px" class="bg-light-blue">지번(주소)</th>
                      <th width="100px">소유구분</th>
                      <th width="120px">
                        고저
                        <tooltip :title="tooltip.pitch.title" :html="tooltip.pitch.html" :size="'hz-lg-tooltip'"></tooltip>
                      </th>
                      <th width="150px">
                        도로조건
                        <tooltip :title="tooltip.road.title" :html="tooltip.road.html" :size="'hz-lg-tooltip'"></tooltip>
                      </th>
                      <th>공시지가(원/㎡)</th>
                      <th >총 공시지가(천원)</th>
                      <th>공시연도</th>
                    </tr>
                    <tr class="table-content" v-for="land in data.oneclick_buji_result['landInfo']">
                      <td class="bg-light-blue">{{ land['mnnmSlno'] | nullCheck }}</td>
                      <td>{{ land['posesnSeCodeNm'] | nullCheck }}</td>
                      <td>{{ land['tpgrphHgCodeNm'] | nullCheck }}</td>
                      <td>{{ land['roadSideCodeNm'] | nullCheck }}</td>
                      <td>{{ land['pblntfPclnd'] | nullCheck | intcomma }}</td>
                      <td>{{ land['pcLnd'] | nullCheck | intcomma }}</td>
                      <td>{{ land['stdrYear'] | nullCheck }}</td>
                    </tr>
                    <tr class="table-content bg-dark-blue font-primary">
                      <td class="font-weight-bold">합계</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{{ data.oneclick_buji_result.landInfoSum[0].sumPblntfPclnd | nullCheck | intcomma }}</td>
                      <td>{{ data.oneclick_buji_result.landInfoSum[0].sumPcLnd | nullCheck | intcomma }}</td>
                      <td></td>
                    </tr>
                  </table>
                </div>
                <!-- 데이터 요청 성공이 아닐 경우 -->
                <div v-else class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th :rowspan="2" class="title">토지<br>기본정보</th>
                      <th width="168px" class="bg-light-blue">지번(주소)</th>
                      <th width="100px">지목 <tooltip :title="tooltip.jimok.title" :html="tooltip.jimok.html" :size="'hz-lg-tooltip'"></tooltip></th>
                      <th width="120px">면적(평)</th>
                      <th width="150px">면적(㎡)</th>
                      <th>지역/지구/구역</th>
                    </tr>
                    <tr class="table-content">
                      <td colspan="5" class="empty">
                        <div v-if="requestState.land.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                        <div v-else class="data-text">{{ requestState.land.text }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 개발행위제한 -->
            <section id="restrict">
              <div class="card-wrap margin-bottom-48">
                <!-- 데이터 요청 성공 -->
                <div v-if="requestState.restrict.state === 'success'" class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header table-sub">
                      <th :rowspan="data.oneclick_buji_result['restrict'].length + 1" class="title">
                        개발<br>행위제한
                        <a href="javascript:void(0)" class="hz-btn-default hz-btn-xs" @click="openSite('https://www.eum.go.kr/web/am/amMain.jsp#')">자세히보기</a>
                      </th>
                      <th width="180px">지역/지구</th>
                      <th width="220px">가능여부</th>
                      <th>조건/제한/예외사항</th>
                    </tr>
                    <tr class="table-content" v-for="restrict in data.oneclick_buji_result['restrict']">
                      <td>{{ restrict['region'] | nullCheck }}</td>
                      <td>{{ restrict['possible'] | nullCheck }}</td>
                      <td>{{ restrict['exception'] | nullCheck }}</td>
                    </tr>
                  </table>
                </div>
                <!-- 데이터 요청 성공이 아닐 경우 -->
                <div v-else class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header sub">
                      <th rowspan="3" class="title">개발<br>행위제한</th>
                      <th width="180px">지역/지구</th>
                      <th width="220px">가능여부</th>
                      <th>조건/제한/예외사항</th>
                    </tr>
                    <tr class="table-content">
                      <td colspan="3" class="empty">
                        <div v-if="requestState.restrict.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                        <div v-else class="data-text">{{ requestState.restrict.text }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 임야정보 -->
            <section id="forest" v-if="isForest">
              <div  class="card-wrap margin-bottom-48">
                <div class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th rowspan="4" class="title">임야정보</th>
                      <th>이름</th>
                      <th>연결</th>
                      <th>주요확인가능 항목</th>
                    </tr>
                    <tr class="table-content">
                      <td>산림청</td>
                      <td><a href="http://gis.kofpi.or.kr/gis/map/main.do?systype=1" target="_blank">바로가기</a></td>
                      <td>경사도, 나무나이, 표고, 방위 등</td>
                    </tr>
                    <tr class="table-content">
                      <td>임상도</td>
                      <td><a href="http://116.67.84.152/forest/?systype=mapSearch&searchOption=stock#/" target="_blank">바로가기</a></td>
                      <td>영급 등</td>
                    </tr>
                    <tr class="table-content">
                      <td>환경성평가</td>
                      <td><a href="https://egis.me.go.kr/map/map.do" target="_blank">바로가기</a></td>
                      <td>생태자연도, 등급 등</td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 건물정보 -->
            <section id="arch " class="m-b-120">
              <div class="card-wrap">
                <div v-if="requestState.arch.state === 'success'" class="card-content">
                  <table v-for="(arch, index) in archData" :class="['col-xs-12', {'border-bottom-none': index < archData.length }]">
                    <tr class="table-header">
                      <th width="148px" class="border-bottom-none" style="font-size: 14px;">건물정보</th>
                      <th v-for="a in arch" class="bg-light-blue" style="font-size: 14px;">{{ a.mnnmSlno | nullCheck }}</th>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">건축 면적(㎡)</td>
                      <td v-for="a in arch">{{ a.archArea | nullCheck | intcomma }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">지상 층수</td>
                      <td v-for="a in arch">{{ a.grndFlrCnt | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">주 용도</td>
                      <td v-for="a in arch">{{ a.mainPurpsCdNm | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">기타 용도</td>
                      <td v-for="a in arch">{{ a.etcPurps | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">주 구조</td>
                      <td v-for="a in arch">{{ a.strctCdNm | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">기타 구조</td>
                      <td v-for="a in arch">{{ a.etcStrct | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">지붕 코드</td>
                      <td v-for="a in arch">{{ a.roofCdNm | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">지붕 기타</td>
                      <td v-for="a in arch">{{ a.etcRoof | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">부속 건축물 수</td>
                      <td v-for="a in arch">{{ a.atchBldCnt | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">부속 건축물 면적(㎡)</td>
                      <td v-for="a in arch">{{ a.atchBldArea | nullCheck | intcomma }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">사용 승인일</td>
                      <td v-for="a in arch">{{ a.useAprDay | nullCheck }}</td>
                    </tr>
                  </table>
                </div>
                <div v-else class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th rowspan="2" width="90Px" style="font-size: 14px; border-bottom: 1px solid #d8d8d8;">건물정보</th>
                      <th class="bg-light-blue">주소</th>
                    </tr>
                    <tr class="table-content">
                      <td class="empty">
                        <div v-if="requestState.arch.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                        <div v-else class="data-text">{{ requestState.arch.text }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!--조례정보 -->
            <section id="examine">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4>조례정보</h4>
                  </div>
                </div>
                <div v-if="requestState.examine.state === 'success'" class="row card-content">
                  <table class="col-xs-12 margin-bottom-16">
                    <tr class="table-header">
                      <th width="300px;">종류</th>
                      <th>법규명</th>
                      <th>제/개정일</th>
                    </tr>
                    <tr class="table-content" v-for="examine in data.oneclick_buji_result['examine']">
                      <td>{{ examine['category'] | nullCheck }}</td>
                      <td>
                        <a href="javascript:void(0)" @click="openSite(examine['link'])" v-html="examine['name']"></a>
                      </td>
                      <td>{{ examine['rev_date'] | nullCheck }}</td>
                    </tr>
                  </table>
                  <div class="col-md-6 col-xs-12 info-box examine-phones-box">
                    <div style="height: 70px;">
                      <a v-if="data.oneclick_buji_result.examine_phones.length > 0" :href="`tel:${data.oneclick_buji_result.examine_phones[0].phone}`">
                        <h4>{{ data.oneclick_buji_result.examine_phones[0].phone | nullCheck }}</h4>
                      </a>
                      <h4 v-else>{{ requestState.examine.text }}</h4>
                      <button class="hz-btn-default hz-btn-xs pull-right" @click="showContactModal('examine')">전화번호 수정요청</button>
                      <p class="category-text" v-if="data.oneclick_buji_result.examine_phones.length > 0">{{ data.oneclick_buji_result.examine_phones[0].name.replace(/ /gi, "/") | nullCheck}}</p>
                      <p class="category-text" v-else>-</p>
                    </div>
                    <div class="info-box-gray">
                      <p class="explain-text">정확한 정보는 꼭 담당자에게 확인하세요.</p>
                    </div>
                  </div>
                  <div class="col-md-6 col-xs-12 info-box examine-box">
                    <div style="height: 70px;">
                      <h4>입법예고 확인</h4>
                      <a href="javascript:void(0)" class="hz-btn-default hz-btn-xs pull-right" @click="openSite('https://www.elis.go.kr/lgsltntc/lgsltNtcList')">입법예고 확인</a>
                    </div>
                    <div class="info-box-gray">
                      <p class="explain-text">제/개정일 시기가 오래된 경우 입법예고를 확인해보세요.</p>
                    </div>
                  </div>
                </div>
                <div v-else class="card-content">
                  <table class="col-xs-12 margin-bottom-16">
                    <tr class="table-header">
                      <th width="300px;">종류</th>
                      <th>법규명</th>
                      <th>제/개정일</th>
                    </tr>
                    <tr class="table-content">
                      <td colspan="3" class="empty">
                        <div v-if="requestState.examine.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                        <div v-else class="data-text">{{ requestState.examine.text }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 전력계통정보 -->
            <section id="electronic">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4>전력계통정보</h4>
                  </div>
                </div>
                <div v-if="requestState.electronic.state === 'success'" class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th>전신주 위치</th>
                      <th>구분</th>
                      <th>변전소</th>
                      <th>변압기</th>
                      <th>D/L</th>
                    </tr>
                    <tr class="table-content">
                      <td rowspan="3" width="276px" class="bg-light-blue">
                        <div class="search-dropdown">
                          <input type="text" maxlength="40"
                                 id="searchInput"
                                 class="hz-input-default"
                                 v-model="data.oneclick_buji_result['selectJibun']"
                                 @click="toggleSearch($event)"
                                 autocomplete="off"
                          />
                          <i v-show="isSearch" class="glyphicon glyphicon-search"></i>
                          <i :class="['glyphicon', {'glyphicon-chevron-down': !isSearch}, {'glyphicon-chevron-up': isSearch}]"
                             @click="toggleSearch($event)"></i>
                          <ul v-show="isSearch" class="dropdown-content">
                            <li v-show="electronicData.length > 0" v-for="electronic in electronicData" @click="getElectronicInfo($event)">{{ electronic }}</li>
                            <li v-show="electronicData.length === 0" class="search-none">검색결과 없음</li>
                          </ul>
                        </div>
                      </td>
                      <td class="sub-header">이름</td>
                      <td>{{ data.oneclick_buji_result.electronic[0].name | nullCheck }}</td>
                      <td>{{ data.oneclick_buji_result.electronic[1].name | nullCheck }}</td>
                      <td>{{ data.oneclick_buji_result.electronic[2].name | nullCheck }}</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header">누적연계용량</td>
                      <td>{{ data.oneclick_buji_result.electronic[0].capacity_cum | nullCheck | intcomma }} kW</td>
                      <td>{{ data.oneclick_buji_result.electronic[1].capacity_cum | nullCheck | intcomma }} kW</td>
                      <td>{{ data.oneclick_buji_result.electronic[2].capacity_cum | nullCheck | intcomma }} kW</td>
                    </tr>
                    <tr class="table-content">
                      <td class="sub-header hz-orange-color">여유용량</td>
                      <td class="hz-orange-color">{{ data.oneclick_buji_result.electronic[0].capacity_free | nullCheck | intcomma }} kW</td>
                      <td class="hz-orange-color">{{ data.oneclick_buji_result.electronic[1].capacity_free | nullCheck | intcomma }} kW</td>
                      <td class="hz-orange-color">{{ data.oneclick_buji_result.electronic[2].capacity_free | nullCheck | intcomma }} kW</td>
                    </tr>
                  </table>
                </div>
                <div v-if="requestState.electronic.state !== 'success'" class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th>전신주 위치</th>
                      <th>구분</th>
                      <th>변전소</th>
                      <th>변압기</th>
                      <th>D/L</th>
                    </tr>
                    <tr class="table-content">
                      <td colspan="5" class="empty">
                        <div v-if="requestState.electronic.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                        <div v-else class="data-text" style="top: 50%;">
                          <p>{{ requestState.electronic.text }}</p>
                          <a href="javascript:void(0)" @click.prevent="openSite('http://home.kepco.co.kr/kepco/CO/H/A/COHAPP001/COHAPP00101_1.do?menuCd=FN040602')">한전 분산형전원 사이트 바로가기</a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-if="requestState.phone.state === 'success'" class="card-content" style="padding: 16px 0;">
                  <div class="info-box" v-if="data.oneclick_buji_result['electronic_phones'].length === 0">
                    <h4>조회된 정보가 없습니다.</h4>
                  </div>
                  <div class="info-box" v-if="data.oneclick_buji_result['electronic_phones'].length > 0">
                    <a :href="`tel:${data.oneclick_buji_result.electronic_phones[0].phone}`">
                      <h4>{{ data.oneclick_buji_result.electronic_phones[0].phone | nullCheck }}</h4>
                    </a>
                    <p class="category-text">{{ data.oneclick_buji_result.electronic_phones[0].name.replace(/ /gi, "/") | nullCheck }}</p>
                  </div>
                  <div class="info-box sub-info-box" v-if="data.oneclick_buji_result['electronic_phones'].length > 1">
                    <a :href="`tel:${data.oneclick_buji_result.electronic_phones[1].phone}`">
                      <h4>{{ data.oneclick_buji_result.electronic_phones[1].phone | nullCheck }}</h4>
                    </a>
                    <p class="category-text">{{ data.oneclick_buji_result.electronic_phones[1].name.replace(/ /gi, "/") | nullCheck }}</p>
                  </div>
                  <div class="info-box-gray">
                    <div style="overflow: hidden; line-height: 24px;">
                      <p class="explain-text">정확한 정보는 꼭 담당자에게 전화로 확인해보세요.</p>
                      <button class="hz-btn-default hz-btn-xs pull-right" @click="showContactModal('electronic')">전화번호 수정요청</button>
                    </div>
                    <div class="margin-top-8" style="overflow: hidden; line-height: 24px;">
                      <p class="explain-text">연계 가능한 전신주 위치와 거리는 지도로 확인해보세요.</p>
                      <a href="javascript:void(0)" class="hz-btn-default hz-btn-xs pull-right"
                         @click="openSite('https://online.kepco.co.kr/PRM076D00')">계통연계비 검토</a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- 발전/수익정보 블라인드 -->
            <section id="blind" v-if="isNewReport && !isPaidMember">
              <div class="card-wrap border-none">
                <div class="card-header">
                  <div class="card-title">
                    <h4>발전/수익정보</h4>
                  </div>
                  <div class="row padding-0">
                    <div class="margin-top-16">
                      <div class="col-md-2 col-sm-3 font-size-12" style="padding: 8px 8px; background-color: #FF7133; color: #ffffff; text-align: center">해줌특허기술</div>
                      <div class="col-md-10 col-sm-9 additional-info font-size-12" style="padding: 8px 8px;">발전정보 결과는 해줌에서 인공지능 기술과 기상 데이터 및 인공위성 영상등을 활용해 도출한 결과입니다.</div>
                    </div>
                  </div>
                </div>
                <div class="card-content">
                  <h4>발전량과 수익이 궁금하세요?</h4>
                  <p>이용권 구매 또는 쿠폰 등록 후<br>무제한 이용해보세요!</p>
                  <button type="button" class="hz-btn-primary hz-btn-lg" @click="$refs.pricingModal.show()">이용권 확인</button>
                  <button type="button" class="hz-btn-default hz-btn-lg" @click="$refs.couponModal.show()">쿠폰받기</button>
                  <p class="margin-0">어떤 정보를 볼 수 있나요?</p>
                  <a href="https://biz.haezoom.com/media/biz/biz_oneclick_sample.pdf" target="_blank">원클릭 보고서 샘플보기</a>
                  <a href="https://biz.haezoom.com/media/biz/biz_extend_sample.pdf" target="_blank">프리미엄 보고서 샘플보기</a>
                </div>
              </div>
            </section>
            <!-- 발전분석 -->
            <section id="analysis" class="m-b-120" v-if="!isNewReport || isPaidMember" >
              <div class="card-wrap border-none">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="title font-dark-blue font-weight-bold">발전정보</h4>
                    <button class="hz-btn-default hz-btn-xs" @click="getAnalysisInfo" title="발전정보 새로고침"><i class="glyphicon glyphicon-refresh"></i></button>
                    <button class="hz-btn-default hz-btn-xs" @click="showMenu('analysis')">설치조건변경</button>
                  </div>
                  <div class="row padding-0">
                    <div class="margin-top-16">
                      <div class="col-md-2 col-sm-3 font-size-12" style="padding: 8px 8px; background-color: #FF7133; color: #ffffff; text-align: center">해줌특허기술</div>
                      <div class="col-md-10 col-sm-9 additional-info font-size-12" style="padding: 8px 8px;">발전정보 결과는 해줌에서 인공지능 기술과 기상 데이터 및 인공위성 영상등을 활용해 도출한 결과입니다.</div>
                    </div>
                  </div>
                </div>
                <div v-if="requestState.analysis.state === 'success'" class="card-content">
                  <div class="have-child">
                    <div class="col-md-4">
                      <div class="border-bottom-line have-child">
                        <div class="yield-title font-size-14 text-align-center margin-top-24 margin-bottom-24">평균발전시간</div>
                        <div class="yield text-align-center col-xs-12 margin-bottom-24">
                          <div class="yield-value font-weight-bold">{{powerData.mu  | nullCheck | intcomma }}<span class="font-dark-blue font-size-14 font-weight-normal"> 시간/일</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="border-bottom-line have-child">
                        <div class="yield-title font-size-14 text-align-center margin-top-24 margin-bottom-24">발전시간 변동 범위</div>
                        <div class="yield text-align-center col-xs-12 margin-bottom-24">
                          <div class="yield-value font-weight-bold">{{powerData.lower_bdd  | nullCheck | intcomma }}~{{powerData.upper_bdd | nullCheck | intcomma }}<span class="font-dark-blue font-size-14 font-weight-normal"> 시간/일</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="border-bottom-line have-child">
                        <div class="yield-title font-size-14 text-align-center margin-top-24 margin-bottom-24">연간 발전량</div>
                        <div class="yield text-align-center col-xs-12 margin-bottom-24">
                          <div class="yield-value font-weight-bold">{{powerData.yearPower | nullCheck | intcomma }}<span class="font-dark-blue font-size-14 font-weight-normal"> kWh/년</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="have-child">
                    <div class="col-md-4">
                      <div class="graph-title">연간 발전시간 변동<span class="pull-right" style="margin-right: 24px">{{powerData.df_monthly.length}}년간</span></div>
                      <generate-time-chart ref="generateTimeChart" v-model="data.oneclick_profit_result.analysis"></generate-time-chart>
                    </div>
                    <div class="col-md-4">
                      <div class="graph-title">발전시간 시뮬레이션<span class="pull-right" style="margin-right: 24px">2000회</span></div>
                      <simulation-time-chart v-model="data.oneclick_profit_result.analysis"></simulation-time-chart>
                    </div>
                    <div class="col-md-4">
                      <div class="graph-title">월별 발전량</div>
                      <month-yield-chart v-model="data.oneclick_profit_result.analysis"></month-yield-chart>
                    </div>
                  </div>
                  <div class="have-child">
                    <div class="font-weight-bold font-size-16 font-dark-blue row" style="margin-top: 81px;">월별 발전량 / 온도 / 일사량</div>
                  </div>
                  <div class="col-xs-12 margin-top-16 padding-0" style="overflow-x: auto;">
                    <table>
                      <tr class="table-division">
                        <th style="padding-left: 5px; text-align: left; width: 150px">구분</th>
                        <th>1월</th>
                        <th>2월</th>
                        <th>3월</th>
                        <th>4월</th>
                        <th>5월</th>
                        <th>6월</th>
                        <th>7월</th>
                        <th>8월</th>
                        <th>9월</th>
                        <th>10월</th>
                        <th>11월</th>
                        <th>12월</th>
                      </tr>
                      <tr class="table-content">
                        <td style="padding-left: 5px; text-align: left; width: 150px">발전량 (kWh)</td>
                        <td v-for="l in powerData.month_yield">{{ l  | nullCheck | intcomma }}</td>
                      </tr>
                      <tr class="table-content">
                        <td style="padding-left: 5px; text-align: left; width: 150px">발전시간 (시간/일)</td>
                        <td v-for="l in powerData.generate_time">{{ l | nullCheck | intcomma }}</td>
                      </tr>
                      <tr class="table-extension">
                        <td class="title" style="text-align: center; width: 150px;">연평균 총 일사량</td>
                        <td class="value" colspan="3" style="text-align: right">{{ data.oneclick_profit_result.analysis.yearly_irr_spot | nullCheck | toFixed(0) | intcomma }}</td>
                        <td class="unit" colspan="2" style="text-align: center; border-right: 1px solid #ced4da;">MJ/m²</td>
                        <td colspan="2" style="text-align: center; width: 5px">평균온도</td>
                        <td class="value" colspan="3" style="text-align: right">{{ data.oneclick_profit_result.analysis.yearly_temp_spot | nullCheck | toFixed(0) | intcomma }}</td>
                        <td class="unit" colspan="2" style="text-align: center">°C</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div v-else class="card-content">
                  <div class="have-child">
                    <div class="font-weight-bold font-size-16 font-dark-blue row">월별 발전량 / 온도 / 일사량</div>
                  </div>
                  <div class="col-xs-12 margin-top-16 padding-0" style="overflow-x: auto;">
                    <table>
                      <tr class="table-division">
                        <th style="padding-left: 5px; text-align: left; width: 150px">구분</th>
                        <th>1월</th>
                        <th>2월</th>
                        <th>3월</th>
                        <th>4월</th>
                        <th>5월</th>
                        <th>6월</th>
                        <th>7월</th>
                        <th>8월</th>
                        <th>9월</th>
                        <th>10월</th>
                        <th>11월</th>
                        <th>12월</th>
                      </tr>
                      <tr class="table-content">
                        <td colspan="13" class="empty" style="padding: 64px 8px;">
                          <div v-if="requestState.analysis.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                          <div v-else class="data-text">{{ requestState.analysis.text }}</div>
                        </td>
                      </tr>
                      <tr class="table-extension">
                        <td class="title" style="text-align: center; width: 150px;">연간 총 일사량</td>
                        <td class="value" colspan="3" style="text-align: right"></td>
                        <td class="unit" colspan="2" style="text-align: center; border-right: 1px solid #ced4da;">- MJ/m2</td>
                        <td colspan="2" style="text-align: center; width: 5px">평균온도</td>
                        <td class="value" colspan="3" style="text-align: right;"></td>
                        <td class="unit" colspan="2" style="text-align: center">- °C</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </section>
            <!-- 수익분석 -->
            <section id="profit" v-if="!isNewReport || isPaidMember">
              <div class="card-wrap">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="title font-dark-blue font-weight-bold">수익정보</h4>
                    <button class="hz-btn-default hz-btn-xs" @click="getProfitInfo" title="수익정보 새로고침"><i class="glyphicon glyphicon-refresh"></i></button>
                    <button class="hz-btn-default hz-btn-xs" @click="showMenu('profit')">수익조건변경</button>
                  </div>
                </div>
                <div v-if="requestState.profit.state === 'success'" class="card-content">
                  <div class="profit-condition-wrap margin-bottom-16">
                    <div class="row">
                      <div class="col-xs-6 profit-condition-label">설치용량</div>
                      <div class="col-xs-6 profit-condition-value">{{ profitCondition.expect_capacity | nullCheck | intcomma}} kWp</div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6 profit-condition-label">시간</div>
                      <div class="col-xs-6 profit-condition-value">{{ profitCondition.average_generate_time | nullCheck | intcomma}} 시간</div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6 profit-condition-label">REC가중치</div>
                      <div class="col-xs-6 profit-condition-value">{{ profitCondition.rec_weight | nullCheck | intcomma}}</div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6 profit-condition-label">REC가격</div>
                      <div class="col-xs-6 profit-condition-value">{{ profitCondition.rec_price | nullCheck | intcomma }} 원</div>
                    </div>
                    <div class="row">
                      <div class="col-xs-6 profit-condition-label">SMP가격</div>
                      <div class="col-xs-6 profit-condition-value">{{ profitCondition.smp_price | nullCheck | intcomma }} 원</div>
                    </div>
                  </div>
                  <div class="have-child row">
                    <div class="col-md-6 col-xs-12">
                      <div class="row">
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-weight-bold font-size-14 text-align-center margin-top-32" style="color: #343a40;">투자 회수기간<br><small>(자기자본금)</small></div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{data.oneclick_profit_result.profit[0].zero_year}}
                                <span style="color: #868e96; margin: -5px; padding-right: 5px;">년</span>
                                {{data.oneclick_profit_result.profit[0].zero_month}}
                                <span style="color: #868e96; margin: -5px">개월</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-weight-bold font-size-14 text-align-center margin-top-32" style="color: #343a40;">연평균 수익 <small>({{ data.oneclick_profit_result.profit[0].business_period }}년)</small></div>
                            <div class="yield text-align-center col-xs-12 margin-top-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{data.oneclick_profit_result.profit[0].avg_year_total_income | billionFormat | intcomma}}
                                <span v-if="data.oneclick_profit_result.profit[0].avg_year_total_income.toString().length >= 9" style="color: #868e96; margin: -5px; padding-right: 5px">억</span>
                                {{data.oneclick_profit_result.profit[0].avg_year_total_income | thousandFormat | intcomma}}
                                <span style="color: #868e96; margin: -5px;">만원</span>
                              </div>
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-bottom-32">
                              <div class="font-size-14 font-weight-bold" style="color: #868e96;">
                                년
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                      <div class="row">
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-weight-bold font-size-14 text-align-center margin-top-32" style="color: #343a40;">월평균 수익 <small>({{ data.oneclick_profit_result.profit[0].business_period }}년)</small></div>
                            <div class="yield text-align-center col-xs-12 margin-top-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{data.oneclick_profit_result.profit[0].avg_month_total_income | billionFormat | intcomma}}
                                <span v-if="data.oneclick_profit_result.profit[0].avg_month_total_income.toString().length >= 9" style="color: #868e96; margin: -5px; padding-right: 5px">억</span>
                                {{data.oneclick_profit_result.profit[0].avg_month_total_income | thousandFormat | intcomma}}
                                <span style="color: #868e96; margin: -5px;">만원</span>
                              </div>
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-bottom-32">
                              <div class="font-size-14 font-weight-bold" style="color: #868e96;">
                                월
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-weight-bold font-size-14 text-align-center margin-top-32" style="color: #343a40;">총 사업비</div>
                            <div class="yield text-align-center col-xs-12 margin-top-48 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{data.oneclick_profit_result.profit[0].invest_total_cost | billionFormat | intcomma}}
                                <span v-if="data.oneclick_profit_result.profit[0].invest_total_cost.toString().length >= 9" style="color: #868e96; margin: -5px; padding-right: 5px">억</span>
                                {{data.oneclick_profit_result.profit[0].invest_total_cost | thousandFormat | intcomma}}
                                <span style="color: #868e96; margin: -5px">만원</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-32">
                    <label class="col-md-1 graptooltip-smallh-title">수익그래프</label>
                    <div class="col-md-7 chart-profit-wrap">
                      <profit-chart v-model="data.oneclick_profit_result.profit[0]"></profit-chart>
                    </div>
                    <div class="col-md-4">
                      <table class="table-extension-2">
                        <tr>
                          <td class="title">누적수익<small> ({{ data.oneclick_profit_result.profit[0].business_period }}년)</small></td>
                          <td class="value">{{data.oneclick_profit_result.profit[0].total_income | billionFormat | intcomma}}<div v-if="data.oneclick_profit_result.profit[0].total_income.toString().length >= 9" style="display: inline-block;">억</div> {{data.oneclick_profit_result.profit[0].total_income | thousandFormat | intcomma}} 만원</td>
                        </tr>
                        <tr>
                          <td class="title">내부수익률<small> (Equity IRR)</small></td>
                          <td class="value">{{data.oneclick_profit_result.profit[0].equity_irr | nullCheck}}<span>%</span></td>
                        </tr>
                        <tr>
                          <td class="title">내부수익률<small> (Project IRR)</small></td>
                          <td class="value">{{data.oneclick_profit_result.profit[0].after_tax_irr_ratio | nullCheck}}<span>%</span></td>
                        </tr>
                        <tr>
                          <td class="title">유지관리비</td>
                          <td class="value">{{data.oneclick_profit_result.profit[0].om_fee | toFixed(2) | intcomma}}<span>백만원/년</span></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="row margin-top-32">
                    <div class="font-size-16 font-weight-bold margin-bottom-16" style="color: #495057;">연도별 자금흐름표</div>
                    <div class="col-xs-12 margin-bottom-48" style="overflow-x: auto; padding: 0;" v-for="(cash, cashIndex) in cashFlowTableData">
                      <table>
                        <tr class="table-division">
                          <th class="col-xs-3" style="padding-left: 8px; text-align: left;">구분</th>
                          <th v-for="(item, index) in cash.smp_total" v-if="cashIndex > 0 || index > 0">{{ cash.start_year + index }}차년</th>
                          <th v-if="cash.is_last">합계</th>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">SMP 매출(a)</td>
                          <td v-for="(item, index) in cash.smp_total" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].smp_total[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">REC 매출(b)</td>
                          <td v-for="(item, index) in cash.rec_total" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].rec_total[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content" style="background-color: #f7f9fa;">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left; font-weight: bold; color: #343a40;">매출합계 (A=a+b)</td>
                          <td v-for="(item, index) in cash.sales_amount" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].sales_amount[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">판매비 & 일반관리비(c)</td>
                          <td v-for="(item, index) in cash.sales_manage_fee" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].sales_manage_fee[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">원금상환(d)</td>
                          <td v-for="(item, index) in cash.principal_amount" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].principal_amount[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">이자비용(e)</td>
                          <td v-for="(item, index) in cash.interest"v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].interest[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left;">법인세(f)</td>
                          <td v-for="(item, index) in cash.crp_fee" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].crp_fee[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content" style="background-color: #f7f9fa; border-bottom: 1px solid #868e96; opacity: 0.9;">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left; font-weight: bold; color: #343a40;">지출합계 (B=c+d+e+f)</td>
                          <td v-for="(item, index) in cash.expense_total" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].expense_total[0] | nullCheck | intcomma }}</td>
                        </tr>
                        <tr class="table-content" style="background-color: #ebeff4; border-bottom: 1px solid #868e96; opacity: 0.9;">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left; font-weight:bold; color: #39496b;">수익</td>
                          <td class="font-weight-bold" style="color: #39496b;" v-for="(item, index) in cash.income" v-if="cashIndex > 0 || index > 0">{{item | nullCheck | intcomma }}</td>
                          <td v-if="cash.is_last">{{cashFlowTableData[0].income[0] | nullCheck | intcomma }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else class="card-content dummy-placeholder">
                  <div class="row">
                    <div class="have-child font-size-16 font-weight-bold" style="color: #495057;">연도별 자금흐름표</div>
                    <div class="col-xs-12 margin-top-16 padding-0" style="overflow-x: auto;">
                      <table>
                        <tr class="table-division">
                          <th class="col-xs-3" style="padding-left: 8px; text-align: left;">구분</th>
                          <th>1차년</th>
                          <th>2차년</th>
                          <th>3차년</th>
                          <th>4차년</th>
                          <th>5차년</th>
                          <th>6차년</th>
                          <th>7차년</th>
                          <th>8차년</th>
                          <th>9차년</th>
                          <th>10차년</th>
                        </tr>
                        <tr class="table-content">
                          <td colspan="11" class="empty" style="padding: 64px 8px;">
                            <div v-if="requestState.profit.state === 'load'" class="data-loader"><bar-loader></bar-loader></div>
                            <div v-else class="data-text">{{ requestState.profit.text }}</div>
                          </td>
                        </tr>
                        <tr class="table-content" style="background-color: #ebeff4; border-bottom: 1px solid #868e96; opacity: 0.9;">
                          <td class="col-xs-3" style="padding-left: 8px; text-align: left; font-weight:bold; color: #39496b;">수익</td>
                          <td colspan="10" class="font-weight-bold" style="color: #39496b;"></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- 작성자 정보 및 안내문구 -->
            <section id="writer">
              <div class="writer-box margin-top-40">
                <div class="col-md-8 padding-0">
                  <div class="col-md-4 padding-0">
                    <label>담당자</label>
                    <p v-show="!writerEdit">{{ data.oneclick_user | nullCheck }}</p>
                    <input type="text" maxlength="40"
                           v-show="writerEdit"
                           class="hz-input-default hz-input-xs"
                           v-model="data.oneclick_user">
                  </div>
                  <div class="col-md-4 padding-0">
                    <label>연락처</label>
                    <p v-show="!writerEdit">{{ data.oneclick_contact | nullCheck }}</p>
                    <input-phone v-show="writerEdit"
                                 class="hz-input-default hz-input-xs text-center"
                                 style="display: inline-block; width: calc(100% - 48px); font-size: 12px;"
                                 v-model="data.oneclick_contact"
                                 :placeholder="'담당자 연락처'">
                    </input-phone>
                  </div>
                  <div class="col-md-4 padding-0">
                    <label>이메일</label>
                    <p v-show="!writerEdit">{{ data.oneclick_email | nullCheck }}</p>
                    <input type="text" maxlength="40"
                           v-show="writerEdit"
                           class="hz-input-default hz-input-xs"
                           v-model="data.oneclick_email">
                  </div>
                </div>
                <div class="col-md-4 padding-0">
                  <p style="color: #868e96;">해당 내용으로 보고서에 출력됩니다.</p>
                  <button v-show="!writerEdit" class="hz-btn-default hz-btn-xs" @click="writerEdit = true">수정</button>
                  <button v-show="writerEdit" class="hz-btn-default hz-btn-xs" @click="writerEdit = false">완료</button>
                </div>
              </div>
              <div class="row have-child margin-top-40" style="width: 100%;">
                <div class="additional-info font-size-12" style="padding: 16px;">
                  <div class="font-size-14 font-weight-bold margin-bottom-16"><유의사항></div>
                  <div >
                    본 서비스의 결과는 실제와 다를 수 있으며 '단순 열람용으로 참조'하시기 바랍니다. <br>이 자료는 법적 효력이 없으며, 이로 인해 발생하는 그 어떠한 손해나 분쟁 등에 대해 해줌은 책임을 지지 않습니다.
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="preview-footer">
            <div class="row">
              <div class="col-xs-12 text-center">
                <button v-if="hasAuthReport" class="hz-btn-default hz-btn-lg" style="border: 1px solid #39496b; color: #39496b; background-color: #ffffff;" type="button" @click="showPremiumModal">{{ premiumBtnName }}</button>
                <button v-if="hasAuthReport" class="hz-btn-default hz-btn-lg" type="button" @click="showSaveModal('copy')">다른이름으로 저장</button>
                <button v-if="isNewReport || hasAuthReport" class="hz-btn-primary hz-btn-lg" type="button" @click.prevent="showSaveModal('save')">저장 후 미리보기</button>
                <button v-if="!isNewReport && !hasAuthReport" class="hz-btn-primary hz-btn-lg" type="button" @click.prevent="openPreview">미리보기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- API 요청 상태 알림창 -->
    <div class="alert-wrap">
      <alert v-for="request in requestState" :key="request.id" :id="request.id" :text="request.text" :state="request.state" @reload="reLoadData"></alert>
    </div>

    <!-- 문의하기 버튼 -->
    <div class="contact-fab">
      <a class="fab fab-text" @click.prevent="showContactModal">문의<br>하기</a>
    </div>

    <!-- 문의하기창 -->
    <contact-modal ref="contactModal" :contactMessage="contactMessage"></contact-modal>


    <!-- 쿠폰받기 알림창 -->
    <modal ref="couponModal" :id="couponModal.id" :type="couponModal.type" :title="couponModal.title"
           :size="couponModal.size" :fields="couponModal.fields" @submit="$router.push({name: 'notice', query: {title: '무료 쿠폰'}})"></modal>

    <!-- 프리미엄 보고서 생성/수정 알림창 -->
    <modal ref="premiumModal" :id="premiumModal.id" :type="premiumModal.type" :title="premiumModal.title"
           :size="premiumModal.size" :fields="premiumModal.fields" @submit="sendDataToPremium(premiumModal.param)"></modal>

    <!-- 이용권 확인 알림창 -->
    <modal ref="pricingModal" :id="pricingModal.id" :type="pricingModal.type" :title="pricingModal.title"
           :size="pricingModal.size" :fields="pricingModal.fields" @submit="$router.push('/pricing')"></modal>

    <!-- 보고서 삭제 알림창 -->
    <modal ref="removeModal" :id="removeModal.id" :type="removeModal.type" :title="removeModal.title"
           :size="removeModal.size" :fields="removeModal.fields" @submit="removeReport"></modal>

    <!-- 보고서 저장 알림창 -->
    <modal ref="saveModal" :id="saveModal.id" :type="saveModal.type" :title="saveModal.title"
           :size="saveModal.size" :fields="saveModal.fields" @submit="submitReport(saveModal.param)" v-model="data"></modal>

    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>
  </div>
</template>

<script>
  import Loader from 'common/components/Loader'
  import DaumMap from 'common/components/Map'
  import InputField from 'common/components/InputText'
  import InputPhone from 'common/components/InputPhone'
  import Tooltip from 'common/components/Tooltip'
  import Modal from 'common/components/Modal'
  import BarLoader from 'common/components/BarLoader'
  import GenerateTimeChart from '@/components/chart/GenerateTimeChart'
  import SimulationTimeChart from '@/components/chart/SimulationTimeChart'
  import MonthYieldChart from '@/components/chart/MonthYieldChart'
  import ProfitChart from '@/components/chart/ProfitChart'
  import LeftSidebar from '@/components/LeftSidebar'
  import ContactModal from '@/components/ContactModal'
  import Alert from '@/components/Alert'
  import api from '@/api/index'
  import eventHub from '@/shared/EventHub'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'oneclick-report',
    components: {
      Loader,
      DaumMap,
      InputField,
      InputPhone,
      LeftSidebar,
      Tooltip,
      ContactModal,
      Modal,
      Alert,
      BarLoader,
      GenerateTimeChart,
      SimulationTimeChart,
      MonthYieldChart,
      ProfitChart
    },
    data () {
      return {
        isRender: false,
        loaderActive: false,
        isFixed: false,
        isSearch: false,
        isForest: false,
        titleEdit: false,
        writerEdit: false,
        sidebarActive: false,
        currentSection: 'land',
        contactMessage: '',
        removeReportId: '',
        data: {
          project_name: '',
          address: [],
          oneclick_status: 'C',
          oneclick_reg_by: '',
          oneclick_update_by: '',
          oneclick_grade: '미정',
          oneclick_examine: '',
          oneclick_memo: '',
          oneclick_profit_condition: {
            expect_capacity: 0,
            plant_type: 'BD',
            unit_price: 160,
            install_fee: 0,
            retaining_fee: 0,
            loan_commission_fee: 0,
            insurance_fee: 0,
            usage_fee: 0,
            land_fee: 0,
            business_etc_fee: 0,
            om_fee: 0,
            connect_fee: 0,
            business_total_cost: 0,
            smp_price: 0,
            rec_price: 0,
            rec_period: 20,
            business_period: 20,
            rec_weight: 0,
            is_hz_algorithm: true,
            average_generate_time: 3.5,
            aspect: 180,
            tilt_angle: 25,
            shade_lose: 0,
            suspension_date_cnt: 0,
            business_type: 'IDV',
            loan_rate: 0,
            loan: 0,
            interest_rate: 0,
            loan_period: 0,
            redemption_period: 0
          },
          oneclick_buji_result: {
            forest: false,
            map: [],
            landInfo: [],
            landInfoSum: [],
            arch: [],
            restrict: [],
            examine: [],
            electronic_phones: [],
            examine_phones: [],
            electronic: [],
            selectJibun: '',
            jibun: {},
            jibunList: []
          },
          oneclick_profit_result: {
            analysis: {},
            profit: []
          },
          oneclick_user: '',
          oneclick_crn: '',
          oneclick_contact: '',
          oneclick_fax: '',
          oneclick_email: '',
          oneclick_company: '',
          oneclick_logo: ''
        },
        requestState: {
          map: { id: 'map', state: '', text: '' },
          land: { id: 'land', state: '', text: '' },
          restrict: { id: 'restrict', state: '', text: '' },
          arch: { id: 'arch', state: '', text: '' },
          examine: { id: 'examine', state: '', text: '' },
          electronic: { id: 'electronic', state: '', text: '' },
          phone: { id: 'phone', state: '', text: '' },
          analysis: { id: 'analysis', state: '', text: '' },
          profit: { id: 'profit', state: '', text: '' }
        },
        profitCondition: {
          expect_capacity: 0,
          average_generate_time: 0,
          rec_weight: 0,
          rec_price: 0,
          smp_price: 0
        },
        powerData: {},
        tooltip: {
          jimok: {
            title: `<table class="tooltip-table" style="margin-bottom: 4px;">
                      <tr style="border-bottom: 1px solid #fff;"><th style="width: 75px;">지목</th><th style="width: 75px;">부호</th><th style="width: 75px;">지목</th><th style="width: 75px;">부호</th></tr>
                      <tr><td>전</td><td>전</td><td>철도용지</td><td>철</td></tr>
                      <tr><td>답</td><td>답</td><td>제방</td><td>제</td></tr>
                      <tr><td>과수원</td><td>과</td><td>하천</td><td>천</td></tr>
                      <tr><td>목장용지</td><td>목</td><td>구거</td><td>구</td></tr>
                      <tr><td>임야</td><td>임</td><td>유지</td><td>유</td></tr>
                      <tr><td>광천지</td><td>광</td><td>양어장</td><td>양</td></tr>
                      <tr><td>염전</td><td>염</td><td>수도용지</td><td>수</td></tr>
                      <tr><td>대</td><td>대</td><td>공원</td><td>공</td></tr>
                      <tr><td>공장용지</td><td>장</td><td>체육용지</td><td>체</td></tr>
                      <tr><td>학교용지</td><td>학</td><td>유원지</td><td>원</td></tr>
                      <tr><td>주차장</td><td>차</td><td>종교용지</td><td>종</td></tr>
                      <tr><td>주유소용지</td><td>주</td><td>사적지</td><td>사</td></tr>
                      <tr><td>창고용지</td><td>창</td><td>묘지</td><td>묘</td></tr>
                      <tr><td>도로</td><td>도</td><td>잡종지</td><td>잡</td></tr>
                    </table>` +
              `<a href="javascript:void(0);" onclick="window.open('https://seereal.lh.or.kr/help/contents.do?bbsId=BBSMSTR_000000000017&nttId=21181', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;"> 자세히보기 </a>`,
            html: true
          },
          pitch: {
            title: `<table class="tooltip-table" style="margin-bottom: 4px;">
                      <tr style="border-bottom: 1px solid #fff;"><th style="width: 100px;">지형지세 : 고저</th><th style="width: 400px;">내용</th></tr>
                      <tr><td>저 지</td><td>간선도로 또는 주위의 지형지세보다 현저히 낮은 지대의 토지</td></tr>
                      <tr><td>평 지</td><td>간선도로 또는 주위의 지형지세와 높이가 비슷하거나 경사도가 미미한 토지</td></tr>
                      <tr><td>완경사</td><td>간선도로 또는 주위의 지형지세보다 높고 경사도가 15°이하인 지대의 토지</td></tr>
                      <tr><td>급경사</td><td>간선도로 또는 주위의 지형지세보다 높고 경사도가 15°를 초과하는 지대의 토지</td></tr>
                      <tr><td>고저</td><td>간선도로 또는 주위의 지형지세보다 현저히 높은 지대의 토지</td></tr>
                    </table>` +
              `<a href="javascript:void(0);" onclick="window.open('https://seereal.lh.or.kr/help/contents.do?bbsId=BBSMSTR_000000000017&nttId=20119', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;"> 자세히보기 </a>`,
            html: true
          },
          road: {
            title: `<table class="tooltip-table" style="margin-bottom: 4px;">
                      <tr style="border-bottom: 1px solid #fff;"><th style="width: 100px;">도로조건 : 도로접면</th><th style="width: 470px;">내용</th></tr>
                      <tr><td>광대한면</td><td>폭 25m이상의 도로에 한면이 접하고 있는 토지</td></tr>
                      <tr><td>광대소각</td><td>광대로에 한면이 접하고 소로(폭 8m이상 12m미만)이상의 도로에 한면 이상 접하고 있는 토지</td></tr>
                      <tr><td>광대세각</td><td>광대로에 한면이 접하면서 자동차 통행이 가능한 세로(가)에 한면 이상 접하고 있는 토지</td></tr>
                      <tr><td>중로한면</td><td>폭 12m이상 25m미만 도로에 한면이 접하고 있는 토지</td></tr>
                      <tr><td>중로각지</td><td>중로에 한면이 접하면서 중로, 소로, 자동차 통행이 가능한 세로(가)에 한면이상 접하고 있는 토지</td></tr>
                      <tr><td>소로한면</td><td>폭 8m이상 12m미만의 도로에 한면이 접하고 있는 토지</td></tr>
                      <tr><td>소로각지</td><td>소로에 한면이 접하면서 소로, 자동차통행이 가능한 세로(가)에 한면이상 접하고 있는 토지</td></tr>
                      <tr><td>세로(가)</td><td>자동차 통행이 가능한 폭 8m미만의 도로에 한 면이 접하고 있는 토지</td></tr>
                      <tr><td>세각(가)</td><td>자동차 통행이 가능한 세로에 두면 이상이 접하고 있는 토지</td></tr>
                      <tr><td>세로(불)</td><td>자동차 통행이 불가능하나 이륜자동차의 통행이 가능한 세로에 한면이 접하고 있는 토지</td></tr>
                      <tr><td>세각(불)</td><td>자동차 통행이 불가능하나 이륜자동차의 통행이 가능한 세로에 두면이상 접하고 있는 토지</td></tr>
                      <tr><td>맹지</td><td>이륜자동차의 통행이 불가능한 도로에 접한 토지와 도로에 접하지 아니한 토지</td></tr>
                    </table>` +
              `<a href="javascript:void(0);" onclick="window.open('https://seereal.lh.or.kr/help/contents.do?bbsId=BBSMSTR_000000000017&nttId=20119', 'preview', 'menubar=0, resizable=0, width=1280, height=720'); return false;"> 자세히보기 </a>`,
            html: true
          }
        },
        couponModal: {
          id: 'couponModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['무료 쿠폰 증정 이벤트를 확인합니다.', '공지사항 페이지로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        pricingModal: {
          id: 'pricingModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['이용권 안내 페이지로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        },
        saveModal: {
          id: 'saveModal',
          type: 'confirm',
          title: '',
          param: '',
          size: 'modal-sm',
          fields: []
        },
        removeModal: {
          id: 'removeModal',
          type: 'confirm',
          title: '보고서삭제',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        },
        premiumModal: {
          id: 'premiumModal',
          type: 'confirm',
          title: '',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    watch: {
      'user': {
        handler: function (val) {
          /**
           * 페이지에 들어온 상태에서 새로고침 시
           * 페이지 초기화 시점보다 유저정보 업데이트 시점이 느리다.
           * 따라서 watch를 통해 user 정보가 업데이트 되는 시점에 권한체크 로직을 수행시킨다.
           */

          if (typeof val.id !== 'undefined') {
            this.$store.dispatch('checkAccessMenu').then(() => { this.init() })
          }
        }
      },
      sidebarActive: _.debounce(() => {
        /**
         * 현재 스크린 사이즈가 1200px 초과 1665 미만 일 경우에만 실행
         * 해당 스크린 사이즈에선 LeftSidebar 활성화 여부에 따라 그래프 레이아웃이 깨지기 때문에
         * 강제로 window resize 이벤트를 발생시켜 c3 차트를 다시 그리게 한다.
         */

        const minWidth = 1199
        const maxWidth = 1665
        const currentWidth = $('body').innerWidth()

        if (minWidth < currentWidth && currentWidth < maxWidth) {
          window.dispatchEvent(new Event('resize'))
        }
      }, 500)
    },
    computed: {
      ...mapGetters({
        user: 'user',
        condition: 'condition',
        isPaidMember: 'isPaidMember'
      }),
      addressTag () {
        const address = this.data.address
        const len = address.length
        let text = address[0]

        if (len > 1) {
          const addressCnt = len - 1
          text += ` 외 ${addressCnt} 곳`
        }

        return text
      },
      archData () {
        // 건물정보는 3개씩 나누어 출력하기 위해 데이터를 가공한다.
        const arch = this.data.oneclick_buji_result.arch

        return _.chunk(arch, 3)
      },
      bodyClass () {
        return this.isFixed ? ['preview-body', 'margin-header'] : ['preview-body']
      },
      electronicData () {
        const bujiData = this.data.oneclick_buji_result
        const select = bujiData.selectJibun
        const electronic = bujiData.electronic
        const jibunList = bujiData.jibunList
        let list = []

        if (electronic.length > 0) {
          // 현재 선택된 지번과 전력계통정보에 지번이 같을경우, 선택된 지번에 값이 비었을 경우 모든 지번목록을 보여준다.
          if (electronic[0].jibun === select || !select) {
            list = jibunList
          } else {
            // 그 외에경우, 지번목록에서 입력된 값을 포함한 목록을 만든다.
            _.filter(jibunList, (item) => {
              if (!item.indexOf(select)) {
                // 같은 지번이 목록에 없을 경우, 값을 넣어준다.
                if (!_.isMatch(jibunList, item)) {
                  list.push(item)
                }
              }
            })
          }
        }

        // 만들어진 지번목록 (검색내역)을 반환한다.
        return list
      },
      cashFlowTableData () {
        /**
         *
         * 연도별 자금흐름표 영역에 사용되는 데이터입니다.
         * 연도별 자금흐름표 테이블은 최대 3개까지 생성되며 사업기간(SMP 기간)에 따라 출력 항목수를 조정합니다.
         * 수익분석 데이터에 SMP 매출, REC 매출, 지출 등의 항목등이 배열 하나로 들어옵니다.
         * 때문에 각 출력될 테이블 갯수만큼에 항목을 나누어 배열안의 배열로 데이터를 분류해주는 작업을 합니다.
         * 각 데이터 배열에는 start_year 항목을 두어 "OO 차년" 데이터 출력 년도수를 출력하는 기준으로 사용합니다.
         * 데이터 배열 마지막 항목에는 is_last 플래그를 활용하여 "합계" 카테고리를 출력합니다.
         *
         */

        const data = _.cloneDeep(this.data.oneclick_profit_result.profit[0])
        const businessPeriod = data.business_period
        let tableData = []
        let tableCnt = 3
        let chunkSize = 0
        let startYear = 0
        let sliceStart = 0
        let sliceEnd = 0

        // 사업기간에 따라 화면에 출력할 테이블 수
        if (businessPeriod < 10) {
          tableCnt = 1
        } else if (businessPeriod < 20) {
          tableCnt = 2
        }

        chunkSize = Math.ceil(data.smp_total.length / tableCnt)
        for (let i = 0; i < tableCnt; i++) {
          startYear = sliceEnd
          sliceStart = sliceEnd
          sliceEnd = i === 0 ? chunkSize + 1 : sliceEnd + chunkSize

          tableData.push({
            is_last: tableCnt === i + 1,
            start_year: startYear,
            smp_total: data.smp_total.slice(sliceStart, sliceEnd),
            rec_total: data.rec_total.slice(sliceStart, sliceEnd),
            sales_amount: data.sales_amount.slice(sliceStart, sliceEnd),
            sales_manage_fee: data.sales_manage_fee.slice(sliceStart, sliceEnd),
            principal_amount: data.principal_amount.slice(sliceStart, sliceEnd),
            interest: data.interest.slice(sliceStart, sliceEnd),
            crp_fee: data.crp_fee.slice(sliceStart, sliceEnd),
            expense_total: data.expense_total.slice(sliceStart, sliceEnd),
            income: data.income.slice(sliceStart, sliceEnd)
          })
        }

        return tableData
      },
      hasAuthReport () {
        // 작성자 본인이거나 백엔드가 editable=true 로 응답하면 (슈퍼유저/팀장/실장) 수정 가능
        return (this.isWriter || this.data.editable === true) && this.isPaidMember
      },
      headerClass () {
        return this.isFixed ? ['preview-header', 'container', 'header-fixed'] : ['preview-header', 'container']
      },
      isNewReport () {
        // 신규 보고서인지 구분한다. (보고서 ID 유무)
        const data = this.data
        const isNewReport = typeof data.reg_by === 'undefined'

        return isNewReport
      },
      isWriter () {
        // 보고서 작성자와 로그인한 사용자가 동일한지 확인한다.
        return this.data.reg_by === this.user.id
      },
      premiumBtnName () {
        // 연결된 프리미엄 보고서 여부에 따라 버튼 문구를 다르게 출력한다.
        const data = this.data
        const btnName = data.extend_status === 'C' ? '프리미엄 보고서 생성' : '프리미엄 보고서 수정'

        return btnName
      },
      stateTagClass () {
        // 추진가능성 태그 클래스 할당
        const grade = this.data.oneclick_grade
        const stateTag = {
          '가능': 'possible-tag',
          '불가': 'impossible-tag',
          '보류': 'hold-tag'
        }

        return stateTag[grade]
      }
    },
    methods: {
      ...mapActions([
        'setReportData',
        'setRecentInputPrice',
        'showToastMessage',
        'getPricingInfo'
      ]),
      init () {
        // URL 파라미터가 없을 경우 비정상적인 접근으로 판단하여 리다이렉트한다.
        const params = this.$route.params
        if ($.isEmptyObject(params)) {
          this.$router.push({name: 'oneclick'})
          return
        }

        // URL 파라미터에 보고서 ID 유무에 따라 신규 또는 저장된 보고서 데이터 분류 작업을 실행한다.
        const isLoad = params.hasOwnProperty('id')
        if (isLoad) {
          this.getReport(params.id)
        } else {
          this.initNewReport(params.address.split('|'))
        }
      },
      initNewReport (address) {
        // 현재 페이지에 데이터와 저장된 데이터를 병합하여 데이터를 초기화 해준다.
        const vm = this
        const data = vm.data
        const user = vm.user
        const userCondition = vm.condition.condition
        const reportCondition = data.oneclick_profit_condition

        // 데이터 초기화
        const dataObj = {
          project_name: address[0],
          address: address,
          oneclick_user: user.pic_name,
          oneclick_contact: user.pic_contact,
          oneclick_email: user.pic_email,
          oneclick_profit_condition: Object.assign({}, reportCondition, userCondition)
        }

        // 현재 데이터와 가공된 데이터를 병합한다.
        vm.data = Object.assign({}, data, dataObj)

        // 화면 렌더
        vm.isRender = true

        // 스크린 사이즈가 PC 일 경우(1200px 이상), 수익조건 메뉴창을 연다.
        vm.sidebarActive = vm.checkScreenWidth()

        vm.$nextTick(() => {
          // 부지정보 데이터 요청
          vm.getMapInfo()
          vm.getLandArchInfo()
          vm.getRestrictInfo()
          vm.getExamineInfo()
          vm.getJibunList()
          vm.getPhoneInfo()
        })
      },
      initLoadReport (response) {
        // 현재 페이지에 데이터와 저장된 데이터를 병합하여 데이터를 초기화 해준다.
        const vm = this
        const data = vm.data
        let loadData = response
        loadData.address = loadData.address.split(',')

        // 보고서 수정 후 서버에서 response를 string으로 줄 경우, JSON 형태로 변환한다.
        if (typeof loadData.oneclick_buji_result === 'string') {
          loadData.oneclick_buji_result = JSON.parse(loadData.oneclick_buji_result)
        }
        if (typeof loadData.oneclick_profit_condition === 'string') {
          loadData.oneclick_profit_condition = JSON.parse(loadData.oneclick_profit_condition)
        }
        if (typeof loadData.oneclick_profit_result === 'string') {
          loadData.oneclick_profit_result = JSON.parse(loadData.oneclick_profit_result)
        }

        // 데이터 및 요청상태 초기화
        vm.data = Object.assign({}, data, loadData)
        vm.requestState = {
          map: { id: 'map', state: '', text: '' },
          land: { id: 'land', state: '', text: '' },
          restrict: { id: 'restrict', state: '', text: '' },
          arch: { id: 'arch', state: '', text: '' },
          examine: { id: 'examine', state: '', text: '' },
          electronic: { id: 'electronic', state: '', text: '' },
          phone: { id: 'phone', state: '', text: '' },
          analysis: { id: 'analysis', state: '', text: '' },
          profit: { id: 'profit', state: '', text: '' }
        }

        vm.$nextTick(() => {
          // 플래그 초기화
          vm.isRender = true
          vm.loaderActive = false
          vm.isFixed = false
          vm.isSearch = false
          vm.titleEdit = false
          vm.isForest = _.find(response.oneclick_buji_result.landInfo, function (o) { return o.lndcgrCodeNm === '임야' })

          // 보고서 미리보기 옵션이 활성화 되었을 경우, 미리보기 창을 연다.
          if (vm.$route.params.preview) {
            vm.openPreview()
          }

          // 스크린 사이즈가 PC 일 경우(1200px 이상), 수익조건 메뉴창을 연다.
          vm.sidebarActive = vm.checkScreenWidth()

          // 수익정보에 출력 할 데이터를 초리화 해준다.
          vm.setDisplayCondition(vm.data.oneclick_profit_condition)

          // 저장된 데이터 상태에 따른 API 요청 상태를 초기화 해준다.
          vm.initRequestState(response)
        })
      },
      initRequestState (data) {
        // 저장된 보고서에 경우, 각 데이터별 유무에 따라 요청 상태를 초기화 한다.
        const bujiData = data.oneclick_buji_result
        const hasMapData = bujiData.map.length > 0
        const hasLandData = bujiData.landInfo.length > 0
        const hasRestrictData = bujiData.restrict.length > 0
        const hasArchData = bujiData.arch.length > 0
        const hasExamineData = bujiData.examine.length > 0
        const hasElectronicData = bujiData.electronic.length > 0
        const hasProfitData = data.oneclick_profit_result.profit.length > 0

        this.requestState = {
          map: { id: 'map', state: hasMapData ? 'success' : 'empty', text: '지도정보 결과없음' },
          land: { id: 'land', state: hasLandData ? 'success' : 'empty', text: '토지정보 결과없음' },
          restrict: { id: 'restrict', state: hasRestrictData ? 'success' : 'empty', text: '개발행위제한정보 결과없음' },
          arch: { id: 'arch', state: hasArchData ? 'success' : 'empty', text: '건물정보 결과없음' },
          examine: { id: 'examine', state: hasExamineData ? 'success' : 'empty', text: '조례정보 결과없음' },
          electronic: { id: 'electronic', state: hasElectronicData ? 'success' : 'empty', text: '전력계통정보 결과없음' },
          phone: { id: 'phone', state: 'success', text: '관련부서정보 결과없음' },
          analysis: { id: 'analysis', state: '', text: '발전분석 결과없음' },
          profit: { id: 'profit', state: hasProfitData ? 'success' : 'empty', text: hasProfitData ? '수익분석 요청성공' : '수익분석 결과없음' }
        }

        // 발전분석정보는 데이터 가공 후 화면 Render
        this.$nextTick(() => {
          const emptyAnalysisData = $.isEmptyObject(data.oneclick_profit_result.analysis)
          if (emptyAnalysisData) {
            this.setRequestState('analysis', 'empty')
          } else {
            this.initPowerData('load')
          }
        })
      },
      initPowerData (type) {
        // 신뢰구간 등 발전분석 차트에 쓰일 데이터를 가공하는 함수.
        const vm = this
        const analysis = vm.data.oneclick_profit_result.analysis
        const condition = vm.data.oneclick_profit_condition

        // 이벤트 호출 시 시뮬레이션 데이터를 넣어준다.
        vm.powerData = analysis['simulate']

        // 시뮬레이션 데이터 후처리
        vm.powerData['simul_axis'] = []
        vm.powerData['simul_value'] = []
        vm.powerData['maxSimulvalue'] = 0
        vm.powerData['maxSimulindex'] = 0
        vm.powerData['maxMonthYield'] = 0
        vm.powerData['simulSolidgrid'] = []
        vm.powerData['yieldSolidgrid'] = []
        vm.powerData['month_yield'] = []
        vm.powerData['generate_time'] = []

        // 신뢰구간
        for (let i in vm.powerData.l_hist_y) {
          if (vm.powerData.maxSimulvalue < vm.powerData.l_hist_y[i][1]) {
            vm.powerData.maxSimulvalue = vm.powerData.l_hist_y[i][1]
            vm.powerData.maxSimulindex = i
          }
          vm.powerData.simul_value.push(vm.powerData.l_hist_y[i][1])
        }

        // let i
        for (let i = 0; i < vm.powerData.maxSimulvalue + 100; i++) {
          if (i % 100 === 0) {
            vm.powerData.simulSolidgrid.push({value: i})
          }
        }

        let start = parseInt(vm.powerData.maxSimulindex) - 8
        let end = parseInt(vm.powerData.maxSimulindex) + 8

        if (start < 0) {
          start = 0
        }

        if (end > vm.powerData.l_hist_x.length) {
          end = vm.powerData.l_hist_x.length
        }

        if (type !== 'load') {
          vm.powerData.upper_bdd_idx = vm.powerData.upper_bdd_idx - start
          vm.powerData.lower_bdd_idx = vm.powerData.lower_bdd_idx - start
        }
        vm.powerData.simul_axis = vm.powerData.l_hist_x.slice(start, end)
        vm.powerData.simul_value = vm.powerData.simul_value.slice(start, end)

        // 월별 발전시간 평균
        let month
        let monthlyGenerate = []
        let monthSum
        for (month = 0; month < 12; month++) {
          monthSum = []
          for (let i = 0; i < vm.powerData.df_monthly.length; i++) {
            if (vm.powerData.df_monthly[i].data.length > month) {
              monthSum.push(vm.powerData.df_monthly[i].data[month])
            }
          }
          monthlyGenerate.push(monthSum)
        }

        let sum
        let monthlyGenerateAvg = []
        let monthlyYieldAvg = []
        for (month = 0; month < 12; month++) {
          sum = 0
          for (let i = 0; i < monthlyGenerate[month].length; i++) {
            sum += monthlyGenerate[month][i]
          }
          monthlyGenerateAvg.push((sum / monthlyGenerate[month].length).toFixed(1))
          monthlyYieldAvg.push((sum / monthlyGenerate[month].length * 30 * 3.14).toFixed(1))
        }

        vm.powerData['generate_time'] = monthlyGenerateAvg
        vm.powerData['month_yield'] = monthlyYieldAvg

        // 월별 발전량 계산
        const monthDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        const capacity = condition['expect_capacity']
        let monthYield
        let yearSum = 0
        for (let i in vm.powerData.month_yield) {
          // 한달 총 발전량 = 용량 * 평균발전시간 * 월의 일수
          monthYield = parseInt(capacity * monthlyGenerateAvg[i] * monthDay[i])
          vm.powerData.month_yield[i] = monthYield
          yearSum += monthYield
        }
        vm.powerData['yearPower'] = yearSum

        for (let i in vm.powerData.month_yield) {
          if (vm.powerData.maxMonthYield < parseInt(vm.powerData.month_yield[i])) {
            vm.powerData.maxMonthYield = parseInt(vm.powerData.month_yield[i])
          }
        }

        for (let i = 0; i < vm.powerData.maxMonthYield; i++) {
          if (i % 10000 === 0) {
            vm.powerData.yieldSolidgrid.push({value: i})
          }
        }

        // 데이터 상태 초기화
        vm.setRequestState('analysis', 'success')
      },
      checkScreenWidth (width = 1199) {
        // 현재 스크린 width를 비교하여 Boolean 값 반환
        return window.innerWidth > width
      },
      checkResponseCode (code) {
        const stateObj = {
          'SC': 'success',
          'RF': 'warning',
          'ND': 'empty'
        }

        return stateObj[code]
      },
      setDisplayCondition (data = null) {
        // 원클릭 사업검토 '수익정보' 영역에 수익조건 출력에 쓰일 데이터 설정
        if (data) {
          this.profitCondition.expect_capacity = data.expect_capacity
          this.profitCondition.average_generate_time = data.average_generate_time
          this.profitCondition.rec_weight = data.rec_weight
          this.profitCondition.rec_price = data.rec_price
          this.profitCondition.smp_price = data.smp_price
        }
      },
      setRequestState (id = '', state = 'load') {
        // 데이터 요청상태를 분류하는 함수
        const nameObj = {
          map: '지도정보',
          land: '토지정보',
          restrict: '개발행위제한정보',
          arch: '건물정보',
          examine: '조례정보',
          electronic: '전력계통정보',
          phone: '관련부서정보',
          analysis: '발전분석',
          profit: '수익분석'
        }

        const stateObj = {
          load: '요청중',
          success: '요청성공',
          warning: '공공데이터 서버오류',
          error: '요청실패',
          empty: '결과없음'
        }

        // 출력할 문구설정
        const text = `${nameObj[id]} ${stateObj[state]}`

        // 데이터 상태 정보를 업데이트한다.
        this.requestState[id].state = state
        this.requestState[id].text = text
      },
      navigate (id) {
        const body = $('body')
        const el = $(`#${id}`)
        const innerWidth = body.innerWidth()

        // 현재 창의 크기에 따른 헤더의 높이를 계산하여 빼준다.
        let headerHeight = innerWidth > 991 ? 224 : 116
        let position = (body.scrollTop() + el.offset().top) - headerHeight

        if (el && typeof el !== 'undefined') {
          $('html,body').stop().animate({scrollTop: (position)}, 500)
        }
      },
      openPreview () {
        const reportId = this.data.id

        // 보고서 저장유무 확인
        if (reportId) {
          const preview = '/preview/' + reportId + '/?type=oneclick'
          const left = (screen.width / 2) - (1280 / 2)
          const top = (screen.height / 2) - (720 / 2)
          const open = window.open(preview, 'preview', 'menubar=0, resizable=0, width=1280, height=720, top=' + top + ', left=' + left)

          // 팝업이 차단되어 있을 경우, 알림창을 띄운다.
          if (open === null || typeof open === 'undefined' || open.screenLeft === 0) {
            // alert('팝업 차단이 설정되어 있습니다. ' +
            //   '\n차단기능을 해제(팝업허용)해주세요. ' +
            //   '\n팝업 차단이 되있을 경우 일부기능이 정상적으로 동작하지 않습니다.')
          }
        }
      },
      openMap () {
        const address = this.data.address
        const routeData = this.$router.resolve({name: 'map', query: { address: address.toString() }})

        window.open(routeData.href, '_blank')
      },
      openSite (url) {
        // 외부 사이트 오픈
        let left = (screen.width / 2) - (1280 / 2)
        let top = (screen.height / 2) - (720 / 2)

        window.open(url, 'preview', 'menubar=0, resizable=0, width=1280, height=720, top=' + top + ', left=' + left)
      },
      getReport (id) {
        this.isRender = false
        api.getReport('S', id, response => {
          if (response.error) {
            this.showToastMessage('보고서 불러오기 실패')
            this.$router.push({name: 'oneclick'})
          } else {
            this.initLoadReport(response)
          }
        })
      },
      submitReport (type = 'save') {
        if (type === 'save') {
          // 입력된 SMP, REC 가격을 로컬 스토리지에 저장한다.
          this.setRecentInputPrice({target: 'smp_price', price: this.data.oneclick_profit_condition.smp_price})
          this.setRecentInputPrice({target: 'rec_price', price: this.data.oneclick_profit_condition.rec_price})
          this.saveReport()
        } else {
          this.copyReport()
        }
      },
      saveReport () {
        /**
         * 보고서를 저장, 수정하는 함수입니다.
         * 데이터 요청 유무를 통해 실행여부를 결정합니다. (요청중인 데이터가 있을 경우 실행 X)
         * 아래와 같이 동작합니다.
         * 1. 입력된 수익조건을 토대로 수익성 분석 API를 실행합니다.
         * 2. 수익성 분석이 완료되면 보고서 내용을 저장합니다.
         * 3. 보고서 저장이 완료되면 미리보기 화면을 띄웁니다.
         */

        this.setRequestState('profit', 'load')

        // 보고서 저장 전 입력된 수익조건으로 수익성 분석을 실행한다.
        const condition = _.cloneDeep(this.data.oneclick_profit_condition)
        api.getProfitInfo('S', condition, profitResponse => {
          if (profitResponse.error) {
            this.setRequestState('profit', 'error')
          } else {
            this.data.oneclick_profit_result.profit = profitResponse.profit
            this.data.oneclick_profit_condition = profitResponse.condition
            this.setDisplayCondition(profitResponse.condition)
            this.setRequestState('profit', 'success')

            // 데이터를 이상없이 모두 불러온 경우, 보고서 저장을 실행한다.
            this.$nextTick(() => {
              this.loaderActive = true

              // JSON 형식에 데이터를 텍스트로 변환하여 저장
              let data = _.cloneDeep(this.data)
              data.address = data.address.toString()
              data.oneclick_profit_condition = JSON.stringify(data.oneclick_profit_condition)
              data.oneclick_buji_result = JSON.stringify(data.oneclick_buji_result)
              data.oneclick_profit_result = JSON.stringify(data.oneclick_profit_result)

              // 데이터를 이상없이 모두 불러온 경우, 보고서 저장을 실행한다.
              api.saveReport('S', data, saveResponse => {
                this.loaderActive = false
                if (saveResponse.error) {
                  const message = saveResponse.message ? `보고서 저장실패: ${saveResponse.message}` : '보고서 저장실패'
                  this.showToastMessage(message)
                } else {
                  // 신규 보고서 생성 일 경우, 할당받은 보고서 id를 URL에 설정 및 그리드 Refresh
                  const isNewReport = data.oneclick_status !== 'U'
                  if (isNewReport) {
                    const result = saveResponse.hasOwnProperty('result') ? saveResponse.result : saveResponse
                    this.initLoadReport(result)
                    this.$router.push({name: 'oneclickLoad', params: {id: result.id}})
                    this.isRender = false

                    // 사용자 결제정보 업데이트
                    this.getPricingInfo().catch(() => {
                      this.showToastMessage('사용자 결제정보 업데이트 실패')
                    })
                  }

                  this.showToastMessage('보고서 저장완료')
                  this.openPreview()
                }
              })
            })
          }
        })
      },
      copyReport () {
        const isLoad = _.findKey(this.requestState, (o) => { return o.state === 'load' })
        if (isLoad) {
          this.showNotifyModal(['해당 부지에 대한 분석중입니다.', '분석이 끝난 후 다시 시도해주세요'])
          return
        }

        let data = _.cloneDeep(this.data)
        delete data.id
        data.project_name = this.$refs.saveModal.data.project_name
        data.address = data.address.toString()
        data.oneclick_profit_condition = JSON.stringify(data.oneclick_profit_condition)
        data.oneclick_buji_result = JSON.stringify(data.oneclick_buji_result)
        data.oneclick_profit_result = JSON.stringify(data.oneclick_profit_result)

        // 저장 API 실행
        api.saveReport('S', data, saveResponse => {
          if (saveResponse.error) {
            const message = saveResponse.message ? `보고서 저장실패: ${saveResponse.message}` : '보고서 저장실패'
            this.showToastMessage(message)
          } else {
            this.getReport(saveResponse.id)
            this.$router.push({name: 'oneclickLoad', params: {id: saveResponse.id}})
            this.showToastMessage('보고서 저장완료')

            // 사용자 결제정보 업데이트
            this.getPricingInfo().catch(() => {
              this.showToastMessage('사용자 결제정보 업데이트 실패')
            })
          }
        })
      },
      getMapInfo () {
        const vm = this
        const address = vm.data.address
        const isLoad = vm.requestState.map.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['지도정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
          return false
        } else {
          // API 요청 상태로 변경
          vm.setRequestState('map', 'load')

          // 지도 정보 API 요청
          api.getMapInfo(address, response => {
            if (response.error) {
              // API 상태분류
              vm.setRequestState('map', 'error')
              console.log('get MapInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 지도 정보를 담는다.
              if (code === 'SC') {
                vm.data.oneclick_buji_result['map'] = response.result
              }

              // API 상태처리
              vm.setRequestState('map', vm.checkResponseCode(code))
            }
          })
        }
      },
      getLandArchInfo () {
        const address = this.data.address

        // 토지정보 API
        const landInfo = new Promise((resolve, reject) => {
          api.getLandInfo(`${address}&report_type=S`, response => {
            if (response.error) {
              reject(new Error(response))
            } else {
              resolve(response)
            }
          })
        })

        // 건물정보 API
        const archInfo = new Promise((resolve, reject) => {
          api.getArchInfo(address, response => {
            if (response.error) {
              reject(new Error(response))
            } else {
              resolve(response)
            }
          })
        })

        // 데이터 상태 초기화
        this.setRequestState('land', 'load')
        this.setRequestState('arch', 'load')

        // 부지정보와 건물정보 API 요청
        Promise.all([landInfo, archInfo]).then((response) => {
          const landCode = response[0].code
          const archCode = response[1].code
          let land = []
          let arch = []
          let capacity = 0
          let type = 'LD'
          let area = 0
          let sumArchAreaP = 0

          // 토지정보 요청에 성공했을 경우
          if (landCode === 'SC') {
            land = response[0].result
            capacity = parseFloat(land.landInfoSum[0].expect_capacity.toFixed(3))
            type = land.landInfoSum[0].plant_type
            area = land.landInfoSum[0].sumLndpclArP

            // 토지정보 초기화
            this.data.oneclick_buji_result.landInfo = land.landInfo
            this.data.oneclick_buji_result.landInfoSum = land.landInfoSum

            // 검토하는 부지에 임야가 있을 경우, 임야 정보를 노출한다
            const isForest = _.find(land['landInfo'], (o) => { return o.lndcgrCodeNm === '임야' })
            if (typeof isForest !== 'undefined') {
              this.data.oneclick_buji_result.forest = true
            }
          }

          // 건물정보 요청에 성공했을 경우
          if (archCode === 'SC') {
            arch = response[1].result['arch']
            sumArchAreaP = response[1].result['sumArchAreaP'] // 면적(평)

            // 사업자 유형 - 건물정보 있고 75평 이상이면 건물 아니면 토지정보에서 넘어온 값으로 넣어준다.
            if (arch.length > 0 && sumArchAreaP >= 75) {
              type = 'BD'
              area = sumArchAreaP
            }

            this.data.oneclick_buji_result.arch = arch
          }

          // 부지유형과 면적에 따른 용량 계산 (용량 - 건물이면 /2.5 아니면 /5)
          if (type === 'BD') {
            capacity = parseFloat((area / 2.5).toFixed(3))
          } else {
            capacity = parseFloat((area / 5.0).toFixed(3))
          }

          // 수익조건 용량, 부지유형 업데이트.
          this.data.oneclick_profit_condition.expect_capacity = capacity
          this.data.oneclick_profit_condition.plant_type = type

          // 데이터 상태 초기화
          this.setRequestState('land', this.checkResponseCode(landCode))
          this.setRequestState('arch', this.checkResponseCode(archCode))

          this.$nextTick(() => {
            this.getRecWeight()
            if (this.isPaidMember) {
              // 신규 보고서는 기본값 3.5시간이 아니라 해줌 알고리즘 발전시간(mu)으로 시작해야 하므로
              // 부트스트랩에서만 autoApply 를 명시적으로 켠다.
              this.getAnalysisProfitInfo({ navigate: false, showToastMessage: false, autoApply: true })
            }
          })
        }).catch(() => {
          // API 요청 실패 시, 데이터 상태 변경
          this.setRequestState('land', 'error')
          this.setRequestState('arch', 'error')

          // 발전/수익 분석에 경우 초기 토지-건물 정보가 없을 경우 유효한 계산을 하지 못하기때문에 API 상태를 에러로 처리한다.
          this.setRequestState('analysis', 'error')
          this.setRequestState('profit', 'error')
        })
      },
      getLandInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.land.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['토지정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // API 요청 상태로 변경
          vm.setRequestState('land', 'load')

          // 토지정보 API 요청
          api.getLandInfo(address + '&report_type=S', response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('land', 'error')
              console.log('get LandInfo error!', response)
            } else {
              const code = response.code

              // response code에 따른 상태처리
              if (code === 'SC') {
                const land = response.result

                // 부지정보를 넣어준다.
                vm.data.oneclick_buji_result['landInfo'] = land['landInfo']
                vm.data.oneclick_buji_result['landInfoSum'] = land['landInfoSum']

                // 검토하는 부지에 임야가 있을 경우, 임야정보를 노출한다.
                const isForest = _.find(land['landInfo'], function (o) { return o.lndcgrCodeNm === '임야' })
                vm.data.oneclick_buji_result['forest'] = typeof isForest !== 'undefined'
              }
              // 데이터 상태 초기화
              vm.setRequestState('land', vm.checkResponseCode(code))
            }
          })
        }
      },
      getRestrictInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.restrict.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['개발행위제한정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 데이터 요청중 상태로 변경
          vm.setRequestState('restrict', 'load')
          // 개발행위제한 API 요청
          api.getRestrictInfo(address, response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('restrict', 'error')
              console.log('get RestrictInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 개발행위제한 정보를 담는다.
              if (code === 'SC') {
                vm.data.oneclick_buji_result['restrict'] = response.result
              }

              // 데이터 상태 초기화
              vm.setRequestState('restrict', vm.checkResponseCode(code))
            }
          })
        }
      },
      getArchInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.arch.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['건물정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('arch', 'load')
          // 개발행위제한 API 요청
          api.getArchInfo(address, response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('map', 'error')
              console.log('get archInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 건물정보를 담는다.
              if (code === 'SC') {
                vm.data.oneclick_buji_result['arch'] = response.result['arch']
              }

              // 데이터 상태 초기화
              vm.setRequestState('arch', vm.checkResponseCode(code))
            }
          })
        }
      },
      getExamineInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.examine.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['조례정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('examine', 'load')
          // 조례정보 API 요청
          api.getExamineInfo(address, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('examine', 'error')
              console.log('get ExamineInfo error!', response)
            } else {
              const code = response.code

              // API 요청 성공 시, 조례정보를 담는다.
              if (code === 'SC') {
                vm.data.oneclick_buji_result['examine'] = response.result
              }

              // 데이터 상태 초기화
              vm.setRequestState('examine', vm.checkResponseCode(code))
            }
          })
        }
      },
      getElectronicInfo (event) {
        const vm = this
        // 선택된 지번과 현재 보고서의 주소
        const jibun = event.target.textContent
        const isLoad = vm.requestState.electronic.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['전력계통정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          let addressArr = vm.data.address[0].split(' ')
          // 선택된 지번을 바꿔준다.
          addressArr.pop()
          addressArr.push(jibun)
          // API에 쓰일 주소를 만들어준다.
          const address = addressArr.toString().replace(/,/gi, ' ')

          if (jibun !== vm.selectJibun) {
            vm.setRequestState('electronic', 'load')
            // 현재 선택된 주소로 전력계통 API 호출
            api.getElectronicInfo(address, response => {
              if (response.error) {
                // API 호출 실패 시
                vm.setRequestState('electronic', 'error')
                console.log('get ElectronicInfo fail!', response)
              } else {
                const code = response.code

                // API 호출 성공 시, 현재 지번과 계통정보를 담는다.
                if (code === 'SC') {
                  const electronic = response.result[0]
                  vm.data.oneclick_buji_result['selectJibun'] = electronic[0].jibun
                  vm.data.oneclick_buji_result['electronic'] = electronic
                }

                // 데이터 상태 초기화
                vm.setRequestState('electronic', vm.checkResponseCode(code))
                // 지번검색 모드 종료.
                vm.isSearch = false
              }
            })
          } else {
            // 지번검색 모드 종료.
            vm.isSearch = false
          }
        }
      },
      getJibunList () {
        const vm = this
        const address = vm.data.address[0]
        const isLoad = vm.requestState.electronic.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['전력계통정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 전력계통정보
          const electronicInfo = new Promise((resolve, reject) => {
            api.getElectronicInfo(address, response => {
              // error 발생 시
              if (response.error) {
                reject(Error(response))
              } else {
                resolve(response)
              }
            })
          })
          // 인접지번정보
          const jibunInfo = new Promise((resolve, reject) => {
            api.getJibunList(address, response => {
              // error 발생 시
              if (response.error) {
                reject(Error(response))
              } else {
                resolve(response)
              }
            })
          })

          vm.setRequestState('electronic', 'load')
          // 전력계통정보와 인접지번정보를 모두 불러왔을 경우, 지번목록을 만들어준다.
          Promise.all([electronicInfo, jibunInfo]).then((response) => {
            // 전력계통정보 요청 상태코드
            const electronicCode = response[0].code

            if (electronicCode === 'SC') {
              const electronicData = response[0].result[0]
              const jibunData = response[1].result
              const jibunCode = response[1].code
              let jibun = ''
              let jibunList = []

              // 전력계통정보와 지번목록이 있는 경우에만 실행.
              if (jibunCode === 'SC') {
                jibun = electronicData[0].jibun
                jibunList.push(jibun)
                jibunList = jibunList.concat(jibunData['jibunList'])
              }

              // 계통정보, 계통정보의 지번, 인접지번 정보를 담는다.
              vm.data.oneclick_buji_result['electronic'] = electronicData
              vm.data.oneclick_buji_result['jibun'] = jibunData
              vm.data.oneclick_buji_result['jibunList'] = jibunList
              vm.data.oneclick_buji_result['selectJibun'] = jibun
            }

            // 데이터 상태 초기화
            vm.setRequestState('electronic', vm.checkResponseCode(electronicCode))
          }).catch(error => {
            vm.setRequestState('electronic', 'error')
            console.log('get JibunList error!', error)
          })
        }
      },
      getPhoneInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.phone.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['관련부서정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('phone', 'load')
          // 관련 부서 전화번호 API 요청
          api.getPhoneInfo(address, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('phone', 'error')
              console.log('get phoneInfo!', response)
            } else {
              const code = response.code

              // API 요청 성공 시, 전화번호 정보를 담는다.
              if (code === 'SC') {
                const phone = response.result
                vm.data.oneclick_buji_result['electronic_phones'] = phone['electronic_phones']
                vm.data.oneclick_buji_result['examine_phones'] = phone['examine_phones']
              }

              // 데이터 상태 초기화
              vm.setRequestState('phone', vm.checkResponseCode(code))
            }
          })
        }
      },
      getRecWeight () {
        const vm = this
        const data = {
          expect_capacity: vm.data.oneclick_profit_condition['expect_capacity'],
          plant_type: vm.data.oneclick_profit_condition['plant_type']
        }

        // REC 가중치 API 요청
        api.getRecWeight(data, response => {
          if (response.error) {
            // API 호출 실패 시
            console.log(response)
          } else {
            // 수익조조건에 REC 가중치 값을 넣어준다.
            vm.data.oneclick_profit_condition['rec_weight'] = parseFloat(response.result.toFixed(3))
          }
        })
      },
      getAnalysisProfitInfo (params = { navigate: false, showToastMessage: false, autoApply: false }) {
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return
        }

        if (this.requestState.analysis.state === 'load') {
          this.showNotifyModal(['발전분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.'])
          return
        }

        if (this.requestState.profit.state === 'load') {
          this.showNotifyModal(['수익분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.'])
          return
        }

        let condition = _.cloneDeep(this.data.oneclick_profit_condition)
        const installOption = {
          address: this.data.address[0],
          aspect: parseFloat(condition.aspect),
          tilt_angle: parseFloat(condition.tilt_angle),
          shade_lose: parseFloat(condition.shade_lose),
          suspension_date_cnt: parseFloat(condition.suspension_date_cnt)
        }

        const isValidCondition = this.validateProfitCondition(condition)
        if (isValidCondition) {
          if (params.navigate) {
            this.navigate('analysis')
          }

          // 발전분석 API 호출
          this.setRequestState('analysis', 'load')
          this.setRequestState('profit', 'load')
          api.getAnalysisInfo(installOption, analysisResponse => {
            if (analysisResponse.error) {
              this.setRequestState('analysis', 'error')
              this.setRequestState('profit', 'error')
            } else {
              // 해줌 알고리즘으로 계산된 평균발전시간을 넣어준다.
              // 발전시간은 수익계산에 그대로 투입되는 값이고 사용자가 직접 입력할 수 있으므로,
              // 「자동계산」을 요청한 경우에만 적용한다. (툴팁도 '적용' 이라고 안내한다)
              // 주의 - 이 가드를 지우거나, 신규 보고서 부트스트랩(getLandArchInfo)에서 autoApply: true 를 빼면
              // 기본값 3.5시간이 그대로 수익계산에 들어간다. 서버 기본값도 3.500 이라 에러 없이 숫자만 틀린다.
              if (params.autoApply) {
                this.data.oneclick_profit_condition.average_generate_time = parseFloat(analysisResponse.simulate.mu)
              }
              this.data.oneclick_profit_result.analysis = analysisResponse

              // 발전량 분석 차트 데이터 가공
              this.initPowerData()

              this.$nextTick(() => {
                if (params.navigate) {
                  this.navigate('profit')
                }
                // 수익분석 API 실행
                condition = _.cloneDeep(this.data.oneclick_profit_condition)
                api.getProfitInfo('S', condition, profitResponse => {
                  if (profitResponse.error) {
                    this.setRequestState('profit', 'error')
                  } else {
                    this.data.oneclick_profit_result.profit = profitResponse.profit
                    this.data.oneclick_profit_condition = profitResponse.condition
                    this.setDisplayCondition(profitResponse.condition)
                    this.setRequestState('profit', 'success')
                    this.$refs.leftSidebar.setOldInstallOptions()

                    if (params.showToastMessage) {
                      this.showToastMessage('발전/수익분석 완료')
                    }
                  }
                })
              })
            }
          })
        }
      },
      getAnalysisInfo (params = { navigate: false, showToastMessage: false, autoApply: false }) {
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return
        }

        if (this.requestState.analysis.state === 'load') {
          this.showNotifyModal(['발전분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.'])
          return
        }

        if (params.navigate) {
          this.navigate('analysis')
        }

        // 설치조건
        const condition = _.cloneDeep(this.data.oneclick_profit_condition)
        const installOption = {
          address: this.data.address[0],
          aspect: parseFloat(condition.aspect),
          tilt_angle: parseFloat(condition.tilt_angle),
          shade_lose: parseFloat(condition.shade_lose),
          suspension_date_cnt: parseFloat(condition.suspension_date_cnt)
        }
        // 발전시뮬레이션 API 호출
        this.setRequestState('analysis', 'load')
        api.getAnalysisInfo(installOption, response => {
          if (response.error) {
            this.setRequestState('analysis', 'error')
          } else {
            // 해줌 알고리즘으로 계산된 평균발전시간을 넣어준다.
            // 자동계산을 요청한 경우에만 적용한다
            if (params.autoApply) {
              this.data.oneclick_profit_condition.average_generate_time = parseFloat(response.simulate.mu)
            }
            this.data.oneclick_profit_result.analysis = response
            this.initPowerData()
            this.$refs.leftSidebar.setOldInstallOptions()

            if (params.showToastMessage) {
              this.showToastMessage('발전분석 완료')
            }
          }
        })
      },
      getProfitInfo (params = { navigate: false, showToastMessage: false }) {
        // 유료 회원이 아닐 경우, 알림창을 띄운다.
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return
        }

        // 데이터 요청중 상태 일 경우, 알림창을 띄운다
        if (this.requestState.profit.state === 'load') {
          this.showNotifyModal(['수익분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.'])
          return
        }

        // 수익분석 조건 유효성 체크
        const condition = _.cloneDeep(this.data.oneclick_profit_condition)
        const isValidCondition = this.validateProfitCondition(condition)
        if (isValidCondition) {
          if (params.navigate) {
            this.navigate('profit')
          }

          this.setRequestState('profit', 'load')

          api.getProfitInfo('S', condition, response => {
            if (response.error) {
              this.setRequestState('profit', 'error')
            } else {
              this.data.oneclick_profit_result.profit = response.profit
              this.data.oneclick_profit_condition = response.condition
              this.setDisplayCondition(response.condition)
              this.setRequestState('profit', 'success')

              if (params.showToastMessage) {
                this.showToastMessage('수익분석 완료')
              }
            }
          })
        }
      },
      validateProfitCondition (condition) {
        // 수익성 계산 시 입력 조건에 대한 유효성 검증
        const businessPeriod = condition.business_period // SMP 기간
        const recPeriod = condition.rec_period
        const loanPeriod = condition.loan_period
        const loanRate = condition.loan_rate
        const redemptionPeriod = condition.redemption_period

        // REC 기간이 SMP 기간보다 길 경우 알림창을 띄운다.
        if (businessPeriod < recPeriod) {
          const message = ['REC 기간은 SMP 기간보다 길 수 없습니다.']
          this.showNotifyModal(message)
          return false
        }

        // 대출이 있는데 상환기간이 없을 경우 알림창을 띄운다.
        if (loanRate > 0 && redemptionPeriod === 0) {
          const message = ['상환기간을 입력하세요.']
          this.showNotifyModal(message)
          return false
        }

        // 상환기간과 거치기간의 합이 SMP 기간보다 길 경우 알림창을 띄운다.
        if (redemptionPeriod + loanPeriod > businessPeriod) {
          const message = ['상환기간과 거치기간의 합이 SMP 기간보다 길 수 없습니다.']
          this.showNotifyModal(message)
          return false
        }

        return true
      },
      reLoadData (id) {
        const vm = this
        const Func = function () {
          this.map = function () { vm.getMapInfo() }
          this.land = function () { vm.getLandInfo() }
          this.restrict = function () { vm.getRestrictInfo() }
          this.arch = function () { vm.getArchInfo() }
          this.examine = function () { vm.getExamineInfo() }
          this.electronic = function () { vm.getJibunList() }
          this.phone = function () { vm.getPhoneInfo() }
          this.analysis = function () { vm.getAnalysisInfo() }
          this.profit = function () { vm.getProfitInfo() }
        }
        const reloadFunc = new Func()

        // 데이터 재요청 함수 실행
        reloadFunc[id]()
      },
      updateLandInfo () {
        const vm = this
        const isLoad = _.findKey(vm.requestState, (o) => { return o.state === 'load' })

        // 부지정보에 모든 데이터를 다 불러왔을 경우에만 업데이트 실행
        if (isLoad) {
          const message = ['사업지 분석중입니다.', '사업지분석이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.getMapInfo()
          vm.getLandInfo()
          vm.getRestrictInfo()
          vm.getArchInfo()
          vm.getExamineInfo()
          vm.getJibunList()
          vm.getPhoneInfo()
        }
      },
      toggleSearch (event) {
        const vm = this
        const type = event.target.type
        const isSearch = vm.isSearch
        const select = vm.data.oneclick_buji_result['selectJibun']
        const jibun = vm.data.oneclick_buji_result.electronic[0]['jibun']

        // 이벤트에 대한 예외처리, 클릭된 타겟이 인풋필드이고 검색이 활성화가 되어있다면 아래 이벤트를 실행하지 않는다
        if (type === 'text' && isSearch) return

        // 현재 검색이 활성화 되어 있으며, 선택지번에 입력값과 전력계통정보에 지번이 다를 경우 값 초기화한다
        if (isSearch && select !== jibun) {
          vm.data.oneclick_buji_result['selectJibun'] = jibun
        }
        // 검색창 활성화 시 인풋창에 focus 처리.
        if (!isSearch) {
          document.getElementById('searchInput').focus()
        }
        // 검색활성화 플래그 변경
        vm.isSearch = !isSearch
      },
      divisionArray (data, cnt) {
        // 배열을 지정한 갯수단위로 나눈다.
        if (data) {
          const count = cnt > 0 ? cnt : 0
          return _.chunk(data, count)
        }
      },
      scrollSpy () {
        // 화면이 활성화 상태일경우에만 이벤트 동작
        if (this.isRender) {
          const el = $(window)
          const scrollPosition = el.scrollTop()

          // 스크롤이 헤더에 위치했을 경우, 헤더 고정
          if (el && scrollPosition >= 320) {
            if (!this.isFixed) this.isFixed = true
          } else {
            if (this.isFixed) this.isFixed = false
          }
        }
      },
      showMenu (target = '') {
        this.$refs.leftSidebar.toggleMenu(target)
      },
      removeReport () {
        const vm = this
        const targetReport = vm.removeReportId
        const currentReport = vm.$route.params.id

        // 보고서 삭제 요청
        api.removeReport(targetReport, response => {
          if (response.error) {
            // 보고서 삭제 실패 시, 메세지 출력
            console.log(response.source)
            vm.showToastMessage('보고서 삭제실패')
          } else {
            /*
             *  보고서가 정상적으로 삭제 되었을 경우, 아래와 같이 동작합니다.
             *  현재 페이지가 삭제 되었을 경우, 원클릭 사업검토 인덱스 페이지로 이동 및 메세지 출력
             *  다른 페이지가 삭제 되었을 경우, 보고서 목록 업데이트 및 메세지 출력
             */

            if (Number(targetReport) === Number(currentReport)) {
              vm.$router.push({name: 'oneclick'})
            } else {
              vm.$refs.leftSidebar.$refs.grid.refresh()
            }

            vm.showToastMessage('보고서 삭제완료')
          }
        })
      },
      sendDataToPremium (type) {
        /**
         * 현재 원클릭 사업검토에 데이터를 프리미엄 보고서로 전달하는 함수입니다.
         * 데이터는 Vuex 스토어에 저장하여 전달하는 방식을 사용합니다.
         * 프리미엄 보고서 생성 유무에 따라 URL을 할당합니다.
         * 데이터 전달 후 프리미엄 보고서 제작 화면내에서 저장하면 보고서 정보가 업데이트 됩니다.
         */
        const vm = this

        // 프리미엄 보고서에 쓰일 데이터 형태로 가공하여 반환한다.
        const data = $.extend(true, {}, vm.data)
        const parseData = {
          id: data.id,
          address: data.address,
          creator: data.creator,
          project_name: data.project_name,
          extend_user: data.oneclick_user,
          extend_contact: data.oneclick_contact,
          extend_email: data.oneclick_email,
          extend_grade: data.oneclick_grade,
          extend_memo: data.oneclick_memo,
          extend_examine: data.oneclick_examine,
          extend_buji_result: data.oneclick_buji_result,
          extend_profit_condition: data.oneclick_profit_condition
        }

        // vuex 스토어에 보고서 데이터를 업데이트한다.
        vm.setReportData(parseData)

        vm.$nextTick(() => {
          const urlName = type === 'new' ? 'extendNew' : 'extendLoad'
          vm.$router.push({name: urlName, params: { id: data.id, send: true }})
        })
      },
      showContactModal (type = '') {
        let message = ''

        if (type) {
          const data = this.data
          const address = data.address[0]

          // 조례정보 전화번호 수정요청 일 경우
          if (type === 'examine') {
            const exminePhones = data.oneclick_buji_result.examine_phones
            const phoneNumber = exminePhones.length > 0 ? exminePhones[0].phone : ''
            const picName = exminePhones.length > 0 ? exminePhones[0].name : ''

            message = `조례정보 전화번호 수정요청 \n1. 주소(지역): ${address} \n2. 수정할 전화번호: ${phoneNumber} \n3. 부서/담당자: ${picName} \n4. 수정요청 전화번호: `
          }

          // 전력계통 전화번호 수정요청 일 경우
          if (type === 'electronic') {
            message = `전력계통정보 전화번호 수정요청 \n1. 주소(지역): ${address} \n2. 수정할 전화번호: \n3. 부서/담당자: \n4. 수정요청 전화번호: `
          }
        }

        // 문의내용 초기화
        this.contactMessage = message

        // 문의하기 창 활성화
        this.$refs.contactModal.show()
      },
      showNotifyModal (message = []) {
        // 전달받은 알림 메세지를 설정 후 모달창 활성화
        this.notifyModal.fields[0].message = message
        this.$refs.notifyModal.show()
      },
      showChargeModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showChargeModal')
      },
      showSaveModal (type) {
        /**
         * 보고서 저장, 복사 시 알림창으로 사용자에게 컨펌받을 내용을 정의하는 함수입니다.
         * 보고서 저장 모달을 출력하기 전 유료 회원 여부와 데이터 요청 상태를 체크합니다.
         * 다른 사람이 생성 한 보고서 일 경우 저장을 하지않고 미리보기 창을 띄웁니다.
         * 본인이 생성 한 보고서 일 경우 기존 저장, 복사 알림창을 띄웁니다.
         */

        const vm = this

        // 유료사용자가 아닐 경우, 이용권 구매 알림을 띄운다.
        if (!vm.isPaidMember) {
          vm.showChargeModal()
          return false
        }

        // 데이터 요청중인 상태가 있을 경우, 알림창을 띄운다.
        const isLoad = _.findKey(vm.requestState, (o) => { return o.state === 'load' })
        if (isLoad) {
          const message = ['해당 부지에 대한 분석중입니다.', '분석이 끝난 후 다시 시도해주세요']
          vm.showNotifyModal(message)
          return false
        }

        // 이미 저장된 보고서에 로그인한 유저가 작성자가 아닐 경우, 저장 버튼 클릭 시 미리보기 창을 띄운다.
        const data = vm.data
        const isNewReport = typeof data.reg_by === 'undefined'
        const isCreator = data.reg_by === vm.user.id
        const isSave = type === 'save'

        if (!isNewReport && !isCreator && isSave) {
          vm.openPreview()
          return false
        }

        // 모달창에 출력할 내용을 설정한다
        if (type === 'copy') {
          vm.saveModal['param'] = 'copy'
          vm.saveModal['fields'] = [
            {
              id: 'project_name',
              name: '프로젝트명',
              type: 'text',
              class: 'margin-0',
              helpText: '새로운 프로젝트명을 입력하세요.'
            }
          ]
        } else {
          vm.saveModal['param'] = 'save'
          vm.saveModal['fields'] = [
            {
              type: 'message',
              message: ['보고서를 저장하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }

        // 모달창 활성화
        vm.$refs.saveModal.show()
      },
      showPremiumModal () {
        /**
         * 프리미엄 보고서 생성/수정에 대한 알림창을 띄웁니다.
         * 원클릭 보고서에 연결된 프리미엄 보고서가 없을 경우 신규생성한다.
         * 원클릭 보고서에 연결된 프리미엄 보고서가 있을 경우 현재내용으로 프리미엄 보고서를 업데이트한다.
         */

        const vm = this
        const data = vm.data

        // 데이터 요청중인 상태가 있을 경우, 알림창을 띄운다.
        const isLoad = _.findKey(vm.requestState, (o) => { return o.state === 'load' })
        if (isLoad) {
          const message = ['해당 부지에 대한 분석중입니다.', '분석이 끝난 후 다시 시도해주세요']
          vm.showNotifyModal(message)
          return false
        }

        // 프리미엄 보고서 생성 여부에 따른 알림창 메세지 설정
        const extendStatus = data.extend_status
        if (extendStatus === 'C') {
          vm.premiumModal['param'] = 'new'
          vm.premiumModal['fields'] = [
            {
              type: 'message',
              message: ['현재 검토된 내용으로 신규 프리미엄 보고서를 생성하시겠습니까?'],
              class: 'text-center'
            }
          ]
        } else {
          vm.premiumModal['param'] = 'update'
          vm.premiumModal['fields'] = [
            {
              type: 'message',
              message: ['현재 검토된 내용으로 연결된 프리미엄 보고서를 수정하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }

        // 모달창 활성화
        vm.$refs.premiumModal.show()
      }
    },
    created () {
      /**
       * Vue 인스턴스 생성 후 실행되는 단계입니다.
       * 원클릭 사업검토 페이지 진입 시 localStorage에 jwt token 여부를 확인합니다.
       * 토큰이 없을 경우 로그인 화면으로 이동, 있을 경우 Token validation 합니다.
       * validation 실패할 경우 로그인화면으로 이동, 성공할 경우 페이지를 초기화 합니다.
       */

      const vm = this
      const token = localStorage.getItem('_t')

      if (token) {
        // 토큰 유효성 검증
        vm.$store.dispatch('inspectToken', token).then(() => {
          // 유저 로그인 상태가 활성화 일 경우, 사용자 권한을 체크한다.
          if (typeof vm.user.id !== 'undefined') {
            vm.$store.dispatch('checkAccessMenu').then(() => {
              // 페이지 접근 권한이 있는 사용자의 경우, 페이지 초기화
              vm.init()
            })
          }
        })
      } else {
        // 토큰이 없을 경우, 로그인 화면으로 이동
        vm.$router.push({name: 'login'})
        return false
      }
    },
    mounted () {
      // 헤더를 고정하는 스크롤 이벤트 등록
      $(window).scroll(this.scrollSpy)

      // 보고서 이동 이벤트 등록
      $(document).on('click', '.kendo-grid tbody tr .glyphicon-download-alt', (e) => {
        const id = e.target.getAttribute('rpid')
        this.$refs.leftSidebar.viewDetail(id, null, true)
      })

      // 보고서 삭제 이벤트 등록
      $(document).on('click', '.kendo-grid tbody tr .k-grid-remove', (e) => {
        this.removeReportId = e.target.getAttribute('rpid')
        this.removeModal.fields[0].message = [e.target.title + ' 보고서를 삭제하시겠습니까?']
        this.$refs.removeModal.show()
      })
    },
    beforeDestroy () {
      // 헤더고정 스크롤 이벤트 제거
      $(window).unbind('scroll')

      // 보고서 이동, 삭제 이벤트 해제
      $(document).off('click', '.kendo-grid tbody tr .glyphicon-download-alt')
      $(document).off('click', '.kendo-grid tbody tr .k-grid-remove')

      // 켄도 라이브러리에 의해 생성된 엘리먼트 제거
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/css/components/chart';
</style>

<style lang="scss" scoped>
  #oneclickReport {
    // 지도정보
    #mapPreview {
      display: block;
      width: 100%;
      height: 320px;
      position: relative;
      text-align: center;
      z-index: 1;
      overflow: hidden;
      background-color: #f5f5f5;

      .data-loader {
        position: absolute;
        top: calc(50% - 20px);
        left: calc(50% - 32px);
        transform: translate(-50%, -50%);
      }

      .data-text {
        position: absolute;
        top: 50%;
        width: 100%;
        font-weight: bold;
        color: #868E97;
        z-index: 1;
      }
    }


    // 조례정보, 전력계통정보
    #examine,
    #electronic {
      // 관련부서 정보
      .info-box {
        padding: 20px 0;
        display: inline-block;

        h4 {
          display: inline-block;
          margin: 0;
        }

        .hz-sm-white-btn {
          float: right;
        }

        .category-text {
          margin: 8px 0 0 0;
          font-size: 14px;
          color: $hzc-gray-08;
        }

        .explain-text {
          margin: 24px 0 0 0;
          font-size: 12px;
          color: #FF7133;
        }
      }

      .info-box-gray {
        padding: 16px 8px;
        background-color: $hover-color;
        border-bottom: 1px solid $hzc-gray-06;

        .explain-text {
          display: inline-block;
          margin: 0;
          font-size: 12px;
          color: $hzc-gray-06;
        }

        button, a {
          padding: 0 8px;
        }
      }

      @media (min-width: 992px) {
        .examine-phones-box {
          padding: 20px 24px 0 0;
          border-right: 1px solid #d8d8d8;
        }

        .examine-box {
          padding: 20px 0 0 24px;
        }

        .info-box-gray {
          line-height: 40px;
        }
      }

      @media (min-width: 768px) {
        .sub-info-box {
          padding-left: 32px;
        }
      }
    }

    // 전력계통 정보
    #electronic {
      .search-dropdown {
        line-height: 32px;
        position: relative;

        input {
          width: 100%;
          padding: 0 24px;
          &:read-only {
            padding: 0 8px;
            cursor: pointer;
          }
        }

        i {
          position: absolute;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          color: #343a40;
        }

        .glyphicon-search {
          top: 12px;
          left: 8px;
        }

        .glyphicon-chevron-up, .glyphicon-chevron-down {
          top: 12px;
          right: 8px;
        }

        .dropdown-content {
          overflow-y: auto;
          padding: 0;
          margin: 0;
          list-style-type: none;
          background-color: $hzc-white;
          height: 78px;
          border-width: 0 1px 1px 1px;
          border-style: solid;
          border-color: #ced4da;

          li {
            cursor: pointer;
            height: 32px;
            padding: 0 8px;
            &:hover {
              background-color: darken($hzc-white, 10%);
            }
          }

          .search-none:hover {
            background-color: $hzc-white;
            border: none;
            cursor: initial;
          }
        }
      }

      .info-box-gray {
        @media(max-width: 767px) {
          p { display: block; }
        }
      }
    }

    // 발전, 수익분석 블라인
    #blind {
      .card-content {
        padding: 93px 0 118px;
        background-image: url(../../assets/img/img-report-blind-lg.jpg);
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        text-align: center;
        font-stretch: normal;
        font-style: normal;

        @media (max-width: 767px) {
          background-image: url(../../assets/img/img-report-blind-xs.jpg);
        }
      }

      .card-content h4 {
        margin: 0 0 8px 0;
        font-size: 26px;
        font-weight: bold;
        line-height: 1.31;
        letter-spacing: -1px;
        color: #495057;
      }

      .card-content p {
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: -0.7px;
        color: #495057;
      }

      .card-content button {
        width: 144px;
        margin: 0 4px 24px;
      }

      .card-content a {
        display: block;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: -0.7px;
        text-align: center;
        color: #ff7133;
      }
    }

    // 발전정보, 수익분석
    #analysis,
    #profit {
      table {
        width: 100%;
        min-width: 950px;
        overflow: scroll;
      }

      .table-division {
        border-top: 1px solid #868e96;
        border-bottom: 1px solid #868e96;
        opacity: 0.9;
        th {
          padding: 16px 0px;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          color: #343a40;
        }
      }

      .table-content {
        border-bottom: 1px solid #ced4da;
        opacity: 0.9;
        td {
          padding: 16px 0px;
          font-size: 14px;
          text-align: center;
          color: #343a40;
        }
      }

      .table-extension {
        border-bottom: 1px solid #868e96;
        opacity: 0.9;
        td {
          padding: 30px 0px;
        }
        .title {
          font-size: 14px;
          color: #868e96;
        }
        .value {
          font-size: 24px;
          color: $primary-color-v2;
        }
        .unit {
          font-size: 14px;
          color: #495057;
        }
      }

      .table-extension-2 {
        width: 100%;
        min-width: initial;

        tr {
          height: 68px;
          td {
            border-top: 1px solid #ced4da;
            border-bottom: 1px solid #ced4da;
            letter-spacing: -0.8px;

            &.title {
              width: 50%;
              padding: 16px 8px 16px 16px;
              font-size: 14px;
              color: #868e96;
            }

            &.value {
              width: 50%;
              padding: 16px 16px 16px 8px;
              font-size: 20px;
              color: #495057;
              span {
                font-size: 14px;
                float: right;
                color: #868e96;
              }
            }

            small {
              font-size: 12px;
            }
          }
        }
      }

      .yield-title {
        line-height: 1.14;
        letter-spacing: -0.8px;
        color: #868e96;
      }

      .yield {
        display: table;
        .yield-value {
          font-size: 36px;
          line-height: 1.17;
          color: $primary-color-v2;
          span {
            line-height: 1.14;
          }
        }
      }

      .graph-title {
        margin: 48px 0 56px 0;
        color: $font-color;
        font-size: 16px;
        font-weight: bold;
      }

      @media(max-height: 991px) {
        .graph-title {
          margin: 48px 0 16px 0;
        }
      }
    }

    // 수익분석
    #profit {
      .card-header {
        margin: 120px 0 40px 0;
      }

      .profit-condition-wrap {
        display: inline-block;
        width: 100%;

        .row {
          float: left;
          width: 20%;
          line-height: 30px;
          border-left: 1px solid $border-color;
          &:first-child {
            border: none;
          }
          .col-xs-6 {
            padding: 0;
            text-align: center;
          }

          .profit-condition-label, .profit-condition-value {
            font-size: 12px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: -0.8px;
            color: $font-color;
          }

          .profit-condition-value {
            font-weight: normal;
          }
        }

        @media(max-width: 767px) {
          .row {
            width: 100%;
            border: none;
          }
        }
      }

      .profit-box {
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
        @media (max-width: 767px) {
          .have-child {
            min-height: 192px;
          }
        }
      }

      @media(min-width: 992px) {
        .graph-title {
          margin: 0;
        }
      }

      @media(max-width: 991px) {
        .card-header {
          margin: 56px 0 40px 0;
        }

        .profit-box {
          &:nth-child(1) {
            padding: 0 8px 8px 0;
          }
          &:nth-child(2) {
            padding: 0 0 8px 8px;
          }
          &:nth-child(3) {
            padding: 8px 8px 0 0;
          }
          &:nth-child(4) {
            padding: 8px 0 0 8px;
          }
        }

        #chartProfit {
          margin-bottom: 40px;
        }
      }
    }

    #writer {
      .writer-box {
        overflow: hidden;
        padding: 0 8px;
        line-height: 32px;
        background-color: $hover-color;

        @media (max-width: 991px) { padding: 16px; }

        label {
          width: 40px;
          margin: 4px 0;
          font-weight: bold;
          color: $font-color;
        }
        input {
          width: calc(100% - 48px);
          font-size: 12px;
          text-align: center;
        }
        p {
          width: calc(100% - 48px);
          display: inline-block;
          margin: 4px 0 0 0;
          font-size: 12px;
          color: $font-color;
          text-align: center;
        }
        button {
          float: right;
          margin: 8px 0;
        }
      }
    }

    // Header
    .preview-header {
      padding: 24px 0;
      margin-bottom: 48px;
      background-color: $hzc-white;
      border-bottom: 1px solid $hzc-gray-04;
      overflow: hidden;
      z-index: 3;

      .title-box {
        width: 50%;
        max-width: calc(100% - 350px);
        float: left;
      }

      .title-edit-box {
        width: calc(100% - 32px);
        height: 32px;
        float: left;
      }

      .btn-box {
        width: 50%;
        min-width: 350px;
        margin-top: 8px;
        float: left;
      }

      .title-box, .btn-box {
        .date-tag { color: $hzc-gray-05; }
        .address-tag { color: $hzc-gray-06; }
        .state-tag {
          display: inline-block;
          float: left;
        }

        .project-title {
          display: inline-block;
          font-size: 24px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: -1px;
          color: $font-color;
          line-height: 32px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          float: left;
        }

        .hz-input-default {
          border: 1px solid $hzc-gray-04;
        }

        .glyphicon-pencil {
          top: 11px;
          color: #7a98b6;
          font-size: 12px;
          cursor: pointer;
          float: left;
        }
      }

      @media (max-width: 767px) {
        padding: 16px;

        .title-box {
          max-width: initial;
          width: 100%;
        }
        .btn-box {
          display: none;
        }
      }

    }

    // Header fixed
    .header-fixed {
      position: fixed;
      top: 64px;
      @media (max-width: 767px) { width: 100%; }
    }

    // Preview contents
    .preview-body {
      table {
        min-width: 950px;
        overflow: auto;
        position: initial;

        .table-header {
          th {
            padding: 16px 8px;
            font-size: 12px;
            font-weight: 700;
            text-align: left;
            color: #343a40;
            border-top: 1px solid #868e96;
            border-bottom: 1px solid #868e96;
          }

          .title {
            width: 90px;
            position: relative;
            color: $hzc-gray-07;
            vertical-align: initial;
            padding: 16px 0 0 0;
            text-align: left;
            font-size: 16px;
            border-bottom: 1px solid $hzc-gray-04;

            a {
              position: absolute;
              left: 0;
              bottom: 16px;
            }
          }

          &.sub > th {
            border-top: 1px solid $hzc-gray-06;
          }
        }

        .table-content {
          td {
            padding: 16px 8px;
            font-size: 14px;
            text-align: left;
            color: $hzc-gray-08;
            border-bottom: 1px solid $hzc-gray-04;
          }

          .sub-header {
            font-size: 12px;
            font-weight: bold;
            color: $hzc-gray-07;
          }

          .empty {
            position: relative;
            padding: 80px 8px;
            text-align: center;
          }

          .data-loader {
            position: absolute;
            top: calc(50% - 34px);
            left: calc(50% - 32px);
            transform: translate(-50%, -50%);
          }

          .data-text {
            position: absolute;
            top: 50%;
            width: 100%;
            font-weight: bold;
            color: #868E97;
            z-index: 1;
          }
        }
      }

      @media (max-width: 767px) {
        padding: 0 16px;
      }

      &.margin-header {
        margin-top: 156px;
      }

      .card-wrap {
        .card-header {
          margin-bottom: 40px;

          .card-title {
            overflow: hidden;
            h4 {
              display: inline-block;
              float: left;
              margin: 0;
              font-size: 24px;
              font-weight: bold;
              color: #495057;
            }

            button {
              float: left;
              margin-left: 8px;
            }
          }
        }
        .card-content {
          height: auto;
          overflow-x: auto;
        }
      }

      .additional-info {
        background-color: #f8f8f8;
        padding-left: 16px;
        color: #FF7133;
      }

      .have-child {
        height: auto;
        overflow: hidden;
      }
    }

    // Preview footer
    .preview-footer {
      padding: 48px 0;
      button {
        width: 152px;
        margin: 0 8px;
        @media (max-width: 767px) {
          margin: 8px 0;
          width: 100%;
        }
      }
    }

    // Sidebar active
    &.sidebar-active {
      // 스크린사이즈가 2065px 이상 일 경우, 별도에 레이이아웃 조정이 필요없다.
      @media (min-width: 1200px) and (max-width: 2065px) {
        .sidebar-wrap {
          width: 400px;
          height: 1px;
          float: left;
        }
        .preview-wrap {
          width: calc(100% - 400px);
          height: 100%;
          float: left;
        }
      }

      @media (min-width: 1200px) and (max-width: 1665px) {
        .preview-wrap {
          .preview-content {
            width: calc(100% - 96px);
          }
          .preview-header {
            width: 100%;
          }
          .header-fixed {
            width: calc(100% - 496px);
          }
        }
      }
    }

    // Contact FAB
    .contact-fab {
      .fab {
        position: fixed;
        right: 32px;
        bottom: 32px;
        width: 56px;
        height: 32px;
        border: none;
        border-radius: 4px;
        box-sizing: content-box;
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
        0 1px 18px 0 rgba(0, 0, 0, 0.12),
        0 3px 5px -1px rgba(0, 0, 0, 0.2);
        cursor: pointer;
        outline: none;
        overflow: hidden;
        text-align: center;
        background-color: $primary-color-v2;
        color: $hzc-white;
        font-size: 12px;
        z-index: 2;

        &:hover {
          background-color: darken($primary-color-v2, 10%);
          color: $hzc-white;
        }
      }
      .fab-text {
        padding: 12px 0;
        text-decoration: none;
        font-weight: bold;
      }
    }

    // API Request state Alert UI
    .alert-wrap {
      width: 320px;
      position: fixed;
      top: 184px;
      right: 32px;
      z-index: 7;

      @media (max-width: 767px) {
        width: calc(100% - 16px);
        top: 72px;
        right: 8px;
      }
    }

    // Background Color
    .bg-light-blue { background-color: $hover-color; }
    .bg-dark-blue { background-color: #ebeff4; }

    // Font Color
    .font-dark-blue { color: #495057; }
    .font-primary { color: $primary-color-v2; }

    // Font Weight
    .font-weight-bold { font-weight: bold; }
    .font-weight-normal { font-weight: normal;}

    // Font Size
    .font-size-24 { font-size: 24px; }
    .font-size-16 { font-size: 16px; }
    .font-size-14 { font-size: 14px; }
    .font-size-12 { font-size: 12px; }

    // border
    .border-bottom-line {
      border-bottom: 1px solid #ced4da;
    }

    .m-b-120 {
      margin-bottom: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/oneclick/OneClickReport.vue